(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1108],{

/***/ 35962:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgIconCar = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  width: 19,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M3.625 9.125H6.25M1 5.625l1.75.875 1.112-3.335c.23-.689.344-1.033.557-1.288a1.75 1.75 0 0 1 .702-.506c.309-.121.671-.121 1.397-.121h6.464c.726 0 1.088 0 1.397.121.273.108.514.282.702.506.213.255.328.6.557 1.288L16.75 6.5l1.75-.875m-5.25 3.5h2.625M5.2 6.5h9.1c1.47 0 2.205 0 2.767.286.494.252.895.653 1.147 1.147.286.562.286 1.297.286 2.767v2.363c0 .406 0 .61-.034.778a1.75 1.75 0 0 1-1.375 1.375c-.169.034-.372.034-.779.034h-.437a1.75 1.75 0 0 1-1.75-1.75.438.438 0 0 0-.438-.438H5.814a.438.438 0 0 0-.438.438 1.75 1.75 0 0 1-1.75 1.75h-.438c-.406 0-.61 0-.778-.034a1.75 1.75 0 0 1-1.375-1.375C1 13.672 1 13.47 1 13.063V10.7c0-1.47 0-2.205.286-2.767a2.625 2.625 0 0 1 1.147-1.147C2.995 6.5 3.73 6.5 5.2 6.5Z",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

/* harmony default export */ __webpack_exports__["Z"] = (SvgIconCar);

/***/ }),

/***/ 96669:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgIconGift = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M8 3.8V15M8 3.8H5.525c-.365 0-.714-.147-.972-.41a1.413 1.413 0 0 1-.403-.99c0-.371.145-.727.403-.99.258-.262.607-.41.972-.41C7.45 1 8 3.8 8 3.8Zm0 0h2.475c.365 0 .714-.147.972-.41s.403-.619.403-.99-.145-.727-.403-.99a1.363 1.363 0 0 0-.972-.41C8.55 1 8 3.8 8 3.8Zm5.6 3.5v5.46c0 .784 0 1.176-.153 1.476a1.4 1.4 0 0 1-.611.611c-.3.153-.692.153-1.476.153H4.64c-.784 0-1.176 0-1.476-.153a1.4 1.4 0 0 1-.611-.611c-.153-.3-.153-.692-.153-1.476V7.3M1 4.92v1.26c0 .392 0 .588.076.738a.7.7 0 0 0 .306.306c.15.076.346.076.738.076h11.76c.392 0 .588 0 .738-.076a.7.7 0 0 0 .306-.306C15 6.768 15 6.572 15 6.18V4.92c0-.392 0-.588-.076-.738a.7.7 0 0 0-.306-.306c-.15-.076-.346-.076-.738-.076H2.12c-.392 0-.588 0-.738.076a.7.7 0 0 0-.306.306C1 4.332 1 4.528 1 4.92Z",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

/* harmony default export */ __webpack_exports__["Z"] = (SvgIconGift);

/***/ }),

/***/ 59950:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgIconMoon = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M15 10.274A7.324 7.324 0 0 1 5.309.583 7.325 7.325 0 1 0 15 10.274Z",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

/* harmony default export */ __webpack_exports__["Z"] = (SvgIconMoon);

/***/ }),

/***/ 25056:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgIconPrevious = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  width: 26,
  height: 12,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M5.06 10 2 5.954m0 0L4.999 2M2 5.954l23 .1",
  stroke: "currentColor",
  strokeWidth: 1.6,
  strokeLinecap: "square"
})));

/* harmony default export */ __webpack_exports__["Z"] = (SvgIconPrevious);

/***/ }),

/***/ 96143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42998);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _helpers_withModifiers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34495);




var LineSeparator = function(param) {
    var _width = param.width, width = _width === void 0 ? false : _width, _variant = param.variant, variant = _variant === void 0 ? [] : _variant;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: width ? {
            width: width
        } : {},
        className: (0,_helpers_withModifiers__WEBPACK_IMPORTED_MODULE_1__/* .withModifiers */ .i)("separator", (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(variant), (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default()))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LineSeparator);


/***/ }),

/***/ 50331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78897);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _helpers_withModifiers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34495);



var Spinner = function(param) {
    var _variant = param.variant, variant = _variant === void 0 ? [] : _variant;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,_helpers_withModifiers__WEBPACK_IMPORTED_MODULE_1__/* .withModifiers */ .i)("spinner", variant, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default()))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Spinner);


/***/ }),

/***/ 91983:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_ModalContent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/elements/form/CustomField/index.js + 1 modules
var CustomField = __webpack_require__(56375);
// EXTERNAL MODULE: ./components/elements/Button/index.js + 2 modules
var Button = __webpack_require__(41197);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 1 modules
var formik_esm = __webpack_require__(64636);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./providers/modalProvider.js
var modalProvider = __webpack_require__(51472);
// EXTERNAL MODULE: ./components/configs/axios.js
var axios = __webpack_require__(92375);
;// CONCATENATED MODULE: ./public/icons/icon-book-confirm.svg
var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgIconBookConfirm = props => /*#__PURE__*/react.createElement("svg", _extends({
  width: 30,
  height: 35,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
  d: "M20.672 15.699c-.28.004-.548.115-.748.312l-4.026 3.92-4.027 3.919-1.548-3.634a1.09 1.09 0 0 0-1.438-.592 1.084 1.084 0 0 0-.56 1.45l2.173 5.085a1.086 1.086 0 0 0 1.758.355l9.186-8.944c.322-.31.422-.786.253-1.199a1.089 1.089 0 0 0-1.023-.672Z",
  fill: "#B18D3B"
})), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
  d: "M7.683 0a1.087 1.087 0 0 0-1.068 1.1v1.33h-5.03a1.316 1.316 0 0 0-.103 0c-.557.056-.98.524-.98 1.083v6.442c-.003.05-.003.1 0 .151v23.597c-.001.6.482 1.09 1.083 1.091h26.837c.6-.001 1.085-.49 1.083-1.09V10.124c.004-.06.004-.12 0-.178V3.513a1.087 1.087 0 0 0-1.083-1.082h-5.03V1.099a1.089 1.089 0 1 0-2.174 0v1.332H8.789V1.099A1.083 1.083 0 0 0 7.683 0ZM2.676 4.604h3.94V5.93a1.089 1.089 0 0 0 1.864.784c.204-.21.316-.492.31-.784V4.604h12.427V5.93a1.086 1.086 0 1 0 2.174 0V4.604h3.94v4.34H2.675v-4.34Zm0 6.514H27.33V32.62H2.676V11.118Z",
  fill: "#999"
})));

/* harmony default export */ var icon_book_confirm = (SvgIconBookConfirm);
// EXTERNAL MODULE: ./components/elements/form/Radio/index.js
var Radio = __webpack_require__(87048);
// EXTERNAL MODULE: ./node_modules/lodash-es/capitalize.js
var capitalize = __webpack_require__(26786);
// EXTERNAL MODULE: ./components/pages/single-property/components/Card/components/Reservation/components/ModalContent/ThankYou/styles.module.scss
var styles_module = __webpack_require__(37691);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./providers/SearchContext.js
var SearchContext = __webpack_require__(65079);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./components/helpers/userContactStorage.js
var userContactStorage = __webpack_require__(4472);
;// CONCATENATED MODULE: ./components/pages/single-property/components/Card/components/Reservation/components/ModalContent/ThankYou/index.js














var ThankYou = function(param) {
    var setFieldValue = param.setFieldValue, translations = param.translations, reservationData = param.reservationData, isSubmitting = param.isSubmitting;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var router = (0,next_router.useRouter)();
    var ref8 = (0,react.useState)(""), transport = ref8[0], setTransport = ref8[1];
    var ref9 = (0,react.useState)(""), details = ref9[0], setDetails = ref9[1];
    var ref10 = (0,react.useState)(""), pets = ref10[0], setPets = ref10[1];
    var ref11 = (0,react.useState)(""), arrangements = ref11[0], setArrangements = ref11[1];
    var ref12 = (0,react.useState)(""), grocery = ref12[0], setGrocery = ref12[1];
    var ref13 = (0,react.useState)(""), phone = ref13[0], setPhone = ref13[1];
    var ref14 = (0,SearchContext/* useSearchContext */.AB)(), setReset = ref14.setReset, setReserved = ref14.setReserved;
    // Load saved phone number on mount
    (0,react.useEffect)(function() {
        var contact = (0,userContactStorage/* getUserContact */.ok)();
        if (contact.phone) {
            setPhone(contact.phone);
            setFieldValue("phone", contact.phone);
        }
    }, [
        setFieldValue
    ]);
    // Reset search state on mount - intentionally runs only once to trigger
    // search context reset when the ThankYou component mounts after booking
    (0,react.useEffect)(function() {
        setReset(true);
        setReserved(true);
        setTimeout(function() {
            setReset(false);
            setReserved(false);
        }, 100);
    // Dependencies intentionally empty - run only once on mount
    // eslint-disable-next-line
    }, []);
    // Handler to save phone on blur
    var handlePhoneBlur = function(value) {
        if (value) {
            (0,userContactStorage/* saveUserContact */.KO)({
                phone: value
            });
        }
    };
    // Format dates for display with locale support
    var formatDate = function(dateString) {
        return moment_default()(dateString).locale(router.locale).format("MMMM D, YYYY");
    };
    // Format currency for display
    var formatCurrency = function(cents) {
        var dollars = cents / 100;
        return "$".concat(dollars.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }));
    };
    var checkboxesUnknown = [
        translations === null || translations === void 0 ? void 0 : translations.yes[router.locale],
        translations === null || translations === void 0 ? void 0 : translations.no[router.locale],
        translations === null || translations === void 0 ? void 0 : translations.unknown[router.locale]
    ];
    var checkboxes = [
        translations === null || translations === void 0 ? void 0 : translations.yes[router.locale],
        translations === null || translations === void 0 ? void 0 : translations.no[router.locale]
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, {
        className: classnames_default()((styles_module_default()).form, (styles_module_default()).thanks),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).form__intro,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_book_confirm, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: (styles_module_default()).form__title,
                        children: translations === null || translations === void 0 ? void 0 : translations.title[router.locale]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: translations === null || translations === void 0 ? void 0 : translations.subtitle[router.locale]
                    })
                ]
            }),
            reservationData && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).confirmation_details,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: (styles_module_default()).confirmation_details__title,
                        children: (translations === null || translations === void 0 ? void 0 : (ref = translations.bookingConfirmation) === null || ref === void 0 ? void 0 : ref[router.locale]) || "Booking Confirmation"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (styles_module_default()).confirmation_details__grid,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default()((styles_module_default()).confirmation_details__item, (styles_module_default())["confirmation_details__item--full"]),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: (styles_module_default()).confirmation_details__label,
                                        children: [
                                            (translations === null || translations === void 0 ? void 0 : (ref1 = translations.propertyName) === null || ref1 === void 0 ? void 0 : ref1[router.locale]) || "Property",
                                            ":"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (styles_module_default()).confirmation_details__value,
                                        children: reservationData.property_title
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default()((styles_module_default()).confirmation_details__item, (styles_module_default())["confirmation_details__item--full"]),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: (styles_module_default()).confirmation_details__label,
                                        children: [
                                            (translations === null || translations === void 0 ? void 0 : (ref2 = translations.depositReserved) === null || ref2 === void 0 ? void 0 : ref2[router.locale]) || "Deposit Reserved",
                                            ":"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: (styles_module_default()).confirmation_details__value,
                                        children: [
                                            formatCurrency(reservationData.amounts.deposit_cents),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: (styles_module_default()).confirmation_details__note_inline,
                                                children: [
                                                    " ",
                                                    (translations === null || translations === void 0 ? void 0 : (ref3 = translations.depositNote) === null || ref3 === void 0 ? void 0 : ref3[router.locale]) || "(will be charged upon confirmation)"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (styles_module_default()).confirmation_details__item,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: (styles_module_default()).confirmation_details__label,
                                        children: [
                                            (translations === null || translations === void 0 ? void 0 : (ref4 = translations.checkIn) === null || ref4 === void 0 ? void 0 : ref4[router.locale]) || "Check-in",
                                            ":"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (styles_module_default()).confirmation_details__value,
                                        children: formatDate(reservationData.start_date)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (styles_module_default()).confirmation_details__item,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: (styles_module_default()).confirmation_details__label,
                                        children: [
                                            (translations === null || translations === void 0 ? void 0 : (ref5 = translations.checkOut) === null || ref5 === void 0 ? void 0 : ref5[router.locale]) || "Check-out",
                                            ":"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (styles_module_default()).confirmation_details__value,
                                        children: formatDate(reservationData.end_date)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default()((styles_module_default()).confirmation_details__item, (styles_module_default())["confirmation_details__item--full"]),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: (styles_module_default()).confirmation_details__label,
                                        children: [
                                            (translations === null || translations === void 0 ? void 0 : (ref6 = translations.confirmationNumber) === null || ref6 === void 0 ? void 0 : ref6[router.locale]) || "Confirmation Number",
                                            ":"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: classnames_default()((styles_module_default()).confirmation_details__value, (styles_module_default())["confirmation_details__value--highlight"]),
                                        children: reservationData.confirmation_code
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (styles_module_default()).confirmation_details__note,
                        children: (translations === null || translations === void 0 ? void 0 : (ref7 = translations.emailSent) === null || ref7 === void 0 ? void 0 : ref7[router.locale]) || "A confirmation email has been sent to your email address."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                className: (styles_module_default()).form__label,
                children: translations === null || translations === void 0 ? void 0 : translations.phoneNumber[router.locale]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomField/* default */.Z, {
                name: "phone",
                optional: true,
                onChange: function(e) {
                    var cleanedValue = e.target.value.replace(/[^0-9+()]/g, "");
                    setFieldValue("phone", cleanedValue);
                    setPhone(cleanedValue);
                },
                onBlur: function(e) {
                    return handlePhoneBlur(e.target.value);
                },
                value: phone,
                type: "tel",
                variant: [
                    "full-width",
                    "white"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                className: (styles_module_default()).form__label,
                children: translations === null || translations === void 0 ? void 0 : translations.rentCar[router.locale]
            }),
            checkboxes.map(function(item, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                    variant: [
                        "white"
                    ],
                    name: "car",
                    checkbox: true,
                    value: item,
                    label: (0,capitalize/* default */.Z)(item),
                    checked: transport === item,
                    onChange: function(e) {
                        setTransport(e.target.value);
                        setFieldValue("car", e.target.value);
                    }
                }, "car-".concat(index));
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (styles_module_default()).form__additional,
                children: translations === null || translations === void 0 ? void 0 : translations.rentCarNote[router.locale]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                className: (styles_module_default()).form__label,
                children: translations === null || translations === void 0 ? void 0 : translations.transport[router.locale]
            }),
            checkboxes.map(function(item, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                    variant: [
                        "white"
                    ],
                    name: "transport",
                    checkbox: true,
                    value: item,
                    label: (0,capitalize/* default */.Z)(item),
                    checked: pets === item,
                    onChange: function(e) {
                        setPets(e.target.value);
                        setFieldValue("transport", e.target.value);
                    }
                }, "transport-".concat(index));
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (styles_module_default()).form__additional,
                children: translations === null || translations === void 0 ? void 0 : translations.transportNote[router.locale]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                className: (styles_module_default()).form__label,
                children: translations === null || translations === void 0 ? void 0 : translations.assistance[router.locale]
            }),
            checkboxesUnknown.map(function(item, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                    variant: [
                        "white"
                    ],
                    name: "assistance",
                    checkbox: true,
                    value: item,
                    label: (0,capitalize/* default */.Z)(item),
                    checked: arrangements === item,
                    onChange: function(e) {
                        setArrangements(e.target.value);
                        setFieldValue("assistance", e.target.value);
                    }
                }, "assistance-".concat(index));
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (styles_module_default()).form__additional,
                children: translations === null || translations === void 0 ? void 0 : translations.assistanceNote[router.locale]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                className: (styles_module_default()).form__label,
                children: translations === null || translations === void 0 ? void 0 : translations.food[router.locale]
            }),
            checkboxesUnknown.map(function(item, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                    variant: [
                        "white"
                    ],
                    name: "food",
                    checkbox: true,
                    value: item,
                    label: (0,capitalize/* default */.Z)(item),
                    checked: grocery === item,
                    onChange: function(e) {
                        setGrocery(e.target.value);
                        setFieldValue("food", e.target.value);
                    }
                }, "food-".concat(index));
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                className: (styles_module_default()).form__label,
                children: translations === null || translations === void 0 ? void 0 : translations.foodNote[router.locale]
            }),
            checkboxesUnknown.map(function(item, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                    variant: [
                        "white"
                    ],
                    name: "reservation",
                    checkbox: true,
                    value: item,
                    label: (0,capitalize/* default */.Z)(item),
                    checked: details === item,
                    onChange: function(e) {
                        setDetails(e.target.value);
                        setFieldValue("reservation", e.target.value);
                    }
                }, "reservation-".concat(index));
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                type: "submit",
                arrow: false,
                className: (styles_module_default()).form__submit,
                variant: [
                    "color-accent"
                ],
                disabled: isSubmitting,
                children: isSubmitting ? "Submitting..." : translations === null || translations === void 0 ? void 0 : translations.submit[router.locale]
            })
        ]
    });
};
/* harmony default export */ var ModalContent_ThankYou = (ThankYou);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@stripe/react-stripe-js/dist/react-stripe.umd.js
var react_stripe_umd = __webpack_require__(86664);
// EXTERNAL MODULE: ./node_modules/@stripe/stripe-js/pure.js
var pure = __webpack_require__(97894);
// EXTERNAL MODULE: ./node_modules/nanoid/index.browser.js + 1 modules
var index_browser = __webpack_require__(78647);
// EXTERNAL MODULE: ./components/pages/single-property/StripeComponent/styles.module.scss
var StripeComponent_styles_module = __webpack_require__(39361);
var StripeComponent_styles_module_default = /*#__PURE__*/__webpack_require__.n(StripeComponent_styles_module);
// EXTERNAL MODULE: ./components/elements/Spinner/index.js
var Spinner = __webpack_require__(50331);
// EXTERNAL MODULE: ./components/helpers/withModifiers.js
var withModifiers = __webpack_require__(34495);
// EXTERNAL MODULE: ./components/elements/ProgressIndicator/styles.module.scss
var ProgressIndicator_styles_module = __webpack_require__(97503);
var ProgressIndicator_styles_module_default = /*#__PURE__*/__webpack_require__.n(ProgressIndicator_styles_module);
;// CONCATENATED MODULE: ./components/elements/ProgressIndicator/index.js





var STEP_ORDER = [
    "calculating",
    "payment",
    "reservation",
    "confirmation"
];
var DEFAULT_MESSAGES = {
    calculating: "Calculating price...",
    payment: "Processing payment...",
    reservation: "Creating reservation...",
    confirmation: "Sending confirmation..."
};
var getStepStatus = function(stepName, currentStep) {
    if (!currentStep || !STEP_ORDER.includes(currentStep)) {
        return "pending";
    }
    var stepIndex = STEP_ORDER.indexOf(stepName);
    var currentIndex = STEP_ORDER.indexOf(currentStep);
    if (stepIndex < currentIndex) {
        return "completed";
    } else if (stepIndex === currentIndex) {
        return "active";
    }
    return "pending";
};
var ProgressIndicator = function(param) {
    var _currentStep = param.currentStep, currentStep = _currentStep === void 0 ? null : _currentStep, message = param.message, _variant = param.variant, variant = _variant === void 0 ? [] : _variant;
    var displayMessage = message || DEFAULT_MESSAGES[currentStep] || "";
    var shouldShowSpinner = currentStep !== null && STEP_ORDER.includes(currentStep);
    // Calculate step progress for screen readers
    var currentStepIndex = STEP_ORDER.indexOf(currentStep);
    var stepProgress = currentStepIndex >= 0 ? "Step ".concat(currentStepIndex + 1, " of ").concat(STEP_ORDER.length) : "";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,withModifiers/* withModifiers */.i)("progressIndicator", variant, (ProgressIndicator_styles_module_default())),
        role: "status",
        "aria-live": "polite",
        "aria-label": displayMessage,
        children: [
            stepProgress && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: (ProgressIndicator_styles_module_default()).srOnly,
                children: [
                    stepProgress,
                    ": ",
                    displayMessage
                ]
            }),
            shouldShowSpinner && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ProgressIndicator_styles_module_default()).progressIndicator__spinner,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                    variant: [
                        "darker"
                    ]
                })
            }),
            displayMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ProgressIndicator_styles_module_default()).progressIndicator__message,
                "aria-hidden": "true",
                children: displayMessage
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ProgressIndicator_styles_module_default()).progressIndicator__steps,
                children: STEP_ORDER.map(function(step) {
                    var status = getStepStatus(step, currentStep);
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((ProgressIndicator_styles_module_default()).progressIndicator__step, " ").concat((ProgressIndicator_styles_module_default())["progressIndicator__step--".concat(status)]),
                        "data-step": step,
                        "data-step-status": status,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ProgressIndicator_styles_module_default()).progressIndicator__stepDot
                            }),
                            status === "completed" && /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                className: (ProgressIndicator_styles_module_default()).progressIndicator__stepCheck,
                                width: "12",
                                height: "9",
                                viewBox: "0 0 12 9",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                "aria-hidden": "true",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M1 4.5L4.5 8L11 1",
                                    stroke: "currentColor",
                                    strokeWidth: "2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                })
                            })
                        ]
                    }, step);
                })
            })
        ]
    });
};
/* harmony default export */ var elements_ProgressIndicator = (ProgressIndicator);

;// CONCATENATED MODULE: ./components/pages/single-property/singlePropertyTranslation.js
var singlePropertyTranslations = function() {
    var translationData = {
        welcome: {
            content: {
                imageAlt: {
                    en: "property welcome image",
                    fr: "image de bienvenue de la propri\xe9t\xe9",
                    es: "imagen de bienvenida a la propiedad",
                    nl: "welkomstafbeelding van de accommodatie"
                },
                bathrooms: {
                    en: "Bathrooms",
                    fr: "Salles de bains",
                    es: "Ba\xf1os",
                    nl: "Badkamers"
                }
            },
            card: {
                arrive: {
                    en: "arrive",
                    fr: "arriv\xe9e",
                    es: "llegar",
                    nl: "aankomen"
                },
                depart: {
                    en: "depart",
                    fr: "d\xe9part",
                    es: "salir",
                    nl: "vertrekken"
                },
                guests: {
                    en: "guests",
                    fr: "invit\xe9s",
                    es: "hu\xe9spedes",
                    nl: "gasten"
                },
                beds: {
                    en: "Beds:",
                    fr: "Des lits:",
                    es: "Camas:",
                    nl: "Bedden:"
                },
                bedrooms: {
                    en: "bedrooms",
                    fr: "chambres",
                    es: "dormitorios",
                    nl: "slaapkamers"
                },
                makeReservation: {
                    en: "Make a reservation for",
                    fr: "Faire une r\xe9servation pour un",
                    es: "Haga una reserva para la",
                    nl: "Maak een reservering voor een"
                },
                period: {
                    en: "Your period is between",
                    fr: "Vos r\xe8gles se situent entre",
                    es: "Tu per\xedodo est\xe1 entre",
                    nl: "Je menstruatie ligt tussen"
                },
                and: {
                    en: "and",
                    fr: "et",
                    es: "y",
                    nl: "en"
                },
                representing: {
                    en: "representing",
                    fr: "repr\xe9sentant",
                    es: "representando",
                    nl: "vertegenwoordigen"
                },
                nights: {
                    en: "nights.",
                    fr: "nuits.",
                    es: "noches.",
                    nl: "nachten."
                },
                noGuests: {
                    en: "Number of guests",
                    fr: "Possibilit\xe9 de chambre",
                    es: "Opci\xf3n de dormitorio",
                    nl: "Slaapkamer optie"
                },
                continue: {
                    en: "Continue",
                    fr: "Continuer",
                    es: "Continuar",
                    nl: "Doorgaan"
                },
                bedroomOption: {
                    en: "bedroom option",
                    fr: "Possibilit\xe9 de chambre",
                    es: "Opci\xf3n de dormitorio",
                    nl: "Slaapkamer optie"
                },
                startingAt: {
                    en: "Starting at",
                    fr: "\xc0 partir de",
                    es: "A partir de",
                    nl: "Beginnend om"
                },
                perNight: {
                    en: "per night",
                    fr: "par nuit",
                    es: "por noche",
                    nl: "per nacht"
                },
                minNights: {
                    en: "minimum nights.",
                    fr: "nuits minimum.",
                    es: "noches m\xednimas.",
                    nl: "minimale nachten."
                },
                book: {
                    en: "Book this villa",
                    fr: "R\xe9servez cette villa",
                    es: "Reserva esta villa",
                    nl: "Boek deze villa"
                },
                save: {
                    en: "save",
                    fr: "sauvegarder",
                    es: "ahorrar",
                    nl: "redden"
                },
                share: {
                    en: "share",
                    fr: "partager",
                    es: "compartir",
                    nl: "deel"
                },
                emailMessage: {
                    en: "hey I want to share this with you",
                    fr: "h\xe9, je veux partager \xe7a avec toi",
                    es: "oye quiero compartir esto contigo",
                    nl: "hoi ik wil dit met jullie delen"
                },
                inquire: {
                    en: "request more information",
                    fr: "demander plus d'informations",
                    es: "pida mas informaci\xf3n",
                    nl: "vraag meer informatie aan"
                },
                sold: {
                    en: "Sold",
                    fr: "Vendu",
                    es: "Vendido",
                    nl: "Verkocht"
                },
                freeCar: {
                    en: "Free car",
                    fr: "Voiture gratuite",
                    es: "coche gratis",
                    nl: "Gratis auto"
                },
                freeNight: {
                    en: "Free Night",
                    fr: "Nuit gratuite",
                    es: "Noche libre",
                    nl: "Gratis nacht"
                },
                freeGift: {
                    en: "Free Gift",
                    fr: "Cadeau gratuit",
                    es: "Regalo gratis",
                    nl: "Gratis geschenk"
                },
                interior: {
                    en: "Interior",
                    fr: "Int\xe9rieur",
                    es: "Interior",
                    nl: "Interieur"
                },
                exterior: {
                    en: "Exterior",
                    fr: "Ext\xe9rieur",
                    es: "Exterior",
                    nl: "Buitenkant"
                },
                landsize: {
                    en: "Landsize",
                    fr: "Taille du terrain",
                    es: "Tama\xf1o del terreno",
                    nl: "Landgrootte"
                },
                price: {
                    en: "Price",
                    fr: "Prix",
                    es: "Precio",
                    nl: "Prijs"
                },
                bookingNoLoad: {
                    en: "The booked dates could not be loaded. A form will have to be filled and we will contact you in 24-48 hours.",
                    fr: "Les dates r\xe9serv\xe9es n'ont pas pu \xeatre charg\xe9es. Un formulaire devra \xeatre rempli et nous vous contacterons dans les 24 \xe0 48 heures.",
                    es: "No se pudieron cargar las fechas reservadas. Deber\xe1 rellenar un formulario y nos pondremos en contacto con usted en 24-48 horas.",
                    nl: "De geboekte data konden niet worden geladen. Er moet een formulier worden ingevuld en wij nemen binnen 24-48 uur contact met u op."
                },
                accommodation: {
                    en: "Accommodation",
                    fr: "H\xe9bergement",
                    es: "Alojamiento",
                    nl: "Accommodatie"
                },
                taxesFees: {
                    en: "Taxes & Fees",
                    fr: "Taxes et frais",
                    es: "impuestos y pagos",
                    nl: "Belastingen"
                },
                total: {
                    en: "Total",
                    fr: "Total",
                    es: "Total",
                    nl: "Totaal"
                },
                contactDetails: {
                    en: "Contact Details",
                    fr: "D\xe9tails du contact",
                    es: "Detalles de contacto",
                    nl: "Contact details"
                },
                lessDays: {
                    en: "You have submitted less days than the minimum for this property. Please fill out this form and we will come back to you with more details.",
                    fr: "Vous avez soumis moins de jours que le minimum pour cette propri\xe9t\xe9. Veuillez remplir ce formulaire et nous reviendrons vers vous avec plus de d\xe9tails.",
                    es: "Ha enviado menos d\xedas que el m\xednimo para esta propiedad. Complete este formulario y nos comunicaremos con usted con m\xe1s detalles.",
                    nl: "U heeft minder dagen ingediend dan het minimum voor deze woning. Vul dit formulier in en wij komen bij u terug met meer details."
                },
                issueLoading: {
                    en: "We had an issue loading the booked dates. Please fill out the form and we will contact you",
                    fr: "Nous avons eu un probl\xe8me pour charger les dates r\xe9serv\xe9es. Veuillez remplir le formulaire et nous vous contacterons",
                    es: "Tuvimos un problema al cargar las fechas reservadas. Por favor llena el formulario y nos comunicaremos contigo",
                    nl: "Er is een probleem opgetreden bij het laden van de geboekte data. Vul dan het formulier in en wij nemen contact met u op"
                },
                pricingCalculationError: {
                    en: "Unable to calculate pricing. Please try again or contact us for assistance.",
                    fr: "Impossible de calculer le prix. Veuillez r\xe9essayer ou nous contacter pour obtenir de l'aide.",
                    es: "No se puede calcular el precio. Int\xe9ntelo de nuevo o cont\xe1ctenos para obtener ayuda.",
                    nl: "Kan prijzen niet berekenen. Probeer het opnieuw of neem contact met ons op voor hulp."
                },
                download: {
                    en: "Download rate sheet",
                    fr: "T\xe9l\xe9charger la grille tarifaire",
                    es: "Descargar hoja de tarifas",
                    nl: "Tarievenblad downloaden"
                },
                form: {
                    error: {
                        validName: {
                            en: "Please enter valid name",
                            fr: "Veuillez entrer un nom valide",
                            es: "Por favor ingresa un nombre v\xe1lido",
                            nl: "Voer een geldige naam in"
                        },
                        requiredFirstName: {
                            en: "The first name field is required",
                            fr: "Le champ pr\xe9nom est obligatoire",
                            es: "El campo de nombre es obligatorio.",
                            nl: "Het veld voornaam is verplicht"
                        },
                        requiredLastName: {
                            en: "The last name field is required",
                            fr: "Le champ nom de famille est obligatoire",
                            es: "El campo de apellido es obligatorio",
                            nl: "Het achternaamveld is verplicht"
                        },
                        validEmail: {
                            en: "This email address is not valid.",
                            fr: "Cette adresse e-mail n'est pas valide.",
                            es: "Esta direcci\xf3n de correo electr\xf3nico no es v\xe1lida.",
                            nl: "Dit e-mailadres is niet geldig."
                        },
                        requiredEmail: {
                            en: "The email field is required",
                            fr: "Le champ email est obligatoire",
                            es: "El campo de correo electr\xf3nico es obligatorio.",
                            nl: "Het e-mailveld is verplicht"
                        },
                        requiredFields: {
                            en: "Please fill in the following required fields",
                            fr: "Veuillez remplir les champs obligatoires suivants",
                            es: "Por favor complete los siguientes campos obligatorios",
                            nl: "Vul de volgende verplichte velden in"
                        },
                        maximumGuestsAllowed: {
                            en: "Maximum {count} guests allowed",
                            fr: "Maximum {count} invit\xe9s autoris\xe9s",
                            es: "M\xe1ximo {count} hu\xe9spedes permitidos",
                            nl: "Maximaal {count} gasten toegestaan"
                        }
                    },
                    success: {
                        title: {
                            en: "Your inquiry was successfully sent!",
                            fr: "Votre demande a \xe9t\xe9 envoy\xe9e avec succ\xe8s!",
                            es: "\xa1Su consulta fue enviada exitosamente!",
                            nl: "Uw aanvraag is succesvol verzonden!"
                        },
                        subtitle: {
                            en: "One of our representatives will reach out to you shortly.",
                            fr: "Un de nos repr\xe9sentants vous contactera sous peu.",
                            es: "Uno de nuestros representantes se comunicar\xe1 con usted en breve.",
                            nl: "Een van onze vertegenwoordigers zal binnenkort contact met u opnemen."
                        },
                        button: {
                            en: "Browse More Properties",
                            fr: "Parcourir plus de propri\xe9t\xe9s",
                            es: "Explorar m\xe1s propiedades",
                            nl: "Blader door meer eigendommen"
                        }
                    },
                    fields: {
                        firstName: {
                            en: "First Name:",
                            fr: "Pr\xe9nom:",
                            es: "Nombre de pila:",
                            nl: "Voornaam:"
                        },
                        lastName: {
                            en: "Last Name:",
                            fr: "Nom de famille:",
                            es: "Apellido:",
                            nl: "Achternaam:"
                        },
                        email: {
                            en: "Email Address:",
                            fr: "Adresse e-mail:",
                            es: "Direcci\xf3n de correo electr\xf3nico:",
                            nl: "E-mailadres:"
                        },
                        phone: {
                            en: "Phone Number (optional):",
                            fr: "Num\xe9ro de t\xe9l\xe9phone (facultatif):",
                            es: "Numero de tel\xe9fono (opcional):",
                            nl: "Telefoon nummer (optioneel):"
                        },
                        message: {
                            en: "Message (optional)",
                            fr: "Message (optionnel)",
                            es: "mensaje (opcional)",
                            nl: "Bericht (optioneel)"
                        },
                        submit: {
                            en: "send message",
                            fr: "envoyer le message",
                            es: "enviar mensaje",
                            nl: "bericht versturen"
                        },
                        continue: {
                            en: "Continue",
                            fr: "Continuer",
                            es: "Continuar",
                            nl: "Doorgaan"
                        }
                    },
                    agreement: {
                        en: "I agree to be contacted by St Martin Sotheby's Realty",
                        fr: "J'accepte d'\xeatre contact\xe9 par St Martin Sotheby's Realty",
                        es: "Acepto ser contactado por St Martin Sotheby's Realty",
                        nl: "Ik ga ermee akkoord dat St Martin Sotheby's Realty contact met mij opneemt"
                    }
                },
                stripe: {
                    paymentDetails: {
                        en: "Payment Details",
                        fr: "D\xe9tails de paiement",
                        es: "Detalles del pago",
                        nl: "Betalingsdetails"
                    },
                    error: {
                        en: "There was an error. Please try again !",
                        fr: "Il y avait une erreur. Veuillez r\xe9essayer !",
                        es: "Hubo un error. Int\xe9ntalo de nuevo !",
                        nl: "Er is een fout opgetreden. Probeer het opnieuw!"
                    },
                    confirming: {
                        en: "Confirming Card",
                        fr: "Carte de confirmation",
                        es: "Tarjeta de confirmaci\xf3n",
                        nl: "Kaart bevestigen"
                    },
                    confirm: {
                        en: "Confirm Card",
                        fr: "Confirmer la carte",
                        es: "Confirmar tarjeta",
                        nl: "Bevestig kaart"
                    },
                    calculating: {
                        en: "Calculating pricing...",
                        fr: "Calcul des prix...",
                        es: "Calculando precios...",
                        nl: "Prijzen berekenen..."
                    },
                    processingPayment: {
                        en: "Processing payment...",
                        fr: "Traitement du paiement...",
                        es: "Procesando pago...",
                        nl: "Betaling verwerken..."
                    },
                    creatingReservation: {
                        en: "Creating reservation...",
                        fr: "Cr\xe9ation de la r\xe9servation...",
                        es: "Creando reserva...",
                        nl: "Reservering maken..."
                    },
                    sendingConfirmation: {
                        en: "Sending confirmation...",
                        fr: "Envoi de la confirmation...",
                        es: "Enviando confirmaci\xf3n...",
                        nl: "Bevestiging verzenden..."
                    },
                    tryAgain: {
                        en: "Try Again",
                        fr: "R\xe9essayer",
                        es: "Intentar de nuevo",
                        nl: "Probeer opnieuw"
                    },
                    paymentFailed: {
                        en: "Payment Failed",
                        fr: "Paiement \xe9chou\xe9",
                        es: "Pago fallido",
                        nl: "Betaling mislukt"
                    },
                    paymentFailedMessage: {
                        en: "Your payment could not be processed. Please check your card details and try again.",
                        fr: "Votre paiement n'a pas pu \xeatre trait\xe9. Veuillez v\xe9rifier les d\xe9tails de votre carte et r\xe9essayer.",
                        es: "No se pudo procesar su pago. Verifique los detalles de su tarjeta e intente nuevamente.",
                        nl: "Uw betaling kon niet worden verwerkt. Controleer uw kaartgegevens en probeer het opnieuw."
                    },
                    reservationPending: {
                        en: "Processing Your Booking",
                        fr: "Traitement de votre r\xe9servation",
                        es: "Procesando su reserva",
                        nl: "Uw boeking verwerken"
                    },
                    reservationPendingMessage: {
                        en: "Your payment was successful. We're processing your reservation and you'll receive confirmation within 15 minutes.",
                        fr: "Votre paiement a \xe9t\xe9 effectu\xe9 avec succ\xe8s. Nous traitons votre r\xe9servation et vous recevrez une confirmation dans les 15 minutes.",
                        es: "Su pago fue exitoso. Estamos procesando su reserva y recibir\xe1 la confirmaci\xf3n dentro de 15 minutos.",
                        nl: "Uw betaling is gelukt. We verwerken uw reservering en u ontvangt binnen 15 minuten een bevestiging."
                    },
                    networkError: {
                        en: "Connection Issue",
                        fr: "Probl\xe8me de connexion",
                        es: "Problema de conexi\xf3n",
                        nl: "Verbindingsprobleem"
                    },
                    networkErrorMessage: {
                        en: "We're having trouble connecting. Please check your internet connection and try again.",
                        fr: "Nous avons des difficult\xe9s \xe0 nous connecter. Veuillez v\xe9rifier votre connexion Internet et r\xe9essayer.",
                        es: "Estamos teniendo problemas para conectarnos. Verifique su conexi\xf3n a Internet e intente nuevamente.",
                        nl: "We hebben problemen met verbinden. Controleer uw internetverbinding en probeer het opnieuw."
                    },
                    unknownError: {
                        en: "Something Went Wrong",
                        fr: "Quelque chose a mal tourn\xe9",
                        es: "Algo sali\xf3 mal",
                        nl: "Er is iets misgegaan"
                    },
                    unknownErrorMessage: {
                        en: "An unexpected error occurred. Please try again or contact reservations@sxmsir.com.",
                        fr: "Une erreur inattendue s'est produite. Veuillez r\xe9essayer ou contacter reservations@sxmsir.com.",
                        es: "Ocurri\xf3 un error inesperado. Por favor, int\xe9ntelo de nuevo o p\xf3ngase en contacto con reservations@sxmsir.com.",
                        nl: "Er is een onverwachte fout opgetreden. Probeer het opnieuw of neem contact op met reservations@sxmsir.com."
                    },
                    loadingPayment: {
                        en: "Loading payment form...",
                        fr: "Chargement du formulaire de paiement...",
                        es: "Cargando formulario de pago...",
                        nl: "Betalingsformulier laden..."
                    },
                    paymentUnclear: {
                        en: "Payment Status Unclear",
                        fr: "Statut de paiement incertain",
                        es: "Estado de pago incierto",
                        nl: "Betalingsstatus onduidelijk"
                    },
                    paymentUnclearMessage: {
                        en: "We are verifying your payment. Please do not retry. You will receive confirmation within 15 minutes. If you do not receive confirmation, please contact reservations@sxmsir.com.",
                        fr: "Nous v\xe9rifions votre paiement. Veuillez ne pas r\xe9essayer. Vous recevrez une confirmation dans les 15 minutes. Si vous ne recevez pas de confirmation, veuillez contacter reservations@sxmsir.com.",
                        es: "Estamos verificando su pago. Por favor no intente de nuevo. Recibir\xe1 confirmaci\xf3n en 15 minutos. Si no recibe confirmaci\xf3n, p\xf3ngase en contacto con reservations@sxmsir.com.",
                        nl: "We verifi\xebren uw betaling. Probeer het alstublieft niet opnieuw. U ontvangt binnen 15 minuten een bevestiging. Als u geen bevestiging ontvangt, neem dan contact op met reservations@sxmsir.com."
                    },
                    supportText: {
                        en: "Need help? Contact our support team:",
                        fr: "Besoin d'aide ? Contactez notre \xe9quipe d'assistance :",
                        es: "\xbfNecesitas ayuda? Contacta a nuestro equipo de soporte:",
                        nl: "Hulp nodig? Neem contact op met ons ondersteuningsteam:"
                    },
                    contactSupport: {
                        en: "Contact Support",
                        fr: "Contacter le support",
                        es: "Contactar soporte",
                        nl: "Neem contact op met ondersteuning"
                    },
                    note: {
                        en: "<br />When using the credit card, there is an additional 2% credit card fee.<br />We will contact you to confirm this booking. If arrival is 60+ days away, only a 25% downpayment is required for confirmation",
                        fr: "<br />Lors de l&#39;utilisation de la carte de cr\xe9dit, des frais suppl\xe9mentaires de 2\xa0% sont factur\xe9s.<br /> Nous vous contacterons pour confirmer cette r\xe9servation. Si l&#39;arriv\xe9e est pr\xe9vue dans plus de 60 jours, seul un acompte de 25\xa0% est requis pour la confirmation.",
                        es: "<br />Al utilizar la tarjeta de cr\xe9dito, se aplica un cargo adicional del 2 %.<br /> Nos pondremos en contacto con usted para confirmar esta reserva. Si faltan m\xe1s de 60 d\xedas para la llegada, solo se requiere un pago inicial del 25 % para la confirmaci\xf3n.",
                        nl: "<br />Bij gebruik van de creditcard wordt een extra creditcardtoeslag van 2% in rekening gebracht.<br /> Wij nemen contact met u op om deze boeking te bevestigen. Als de aankomst meer dan 60 dagen duurt, is ter bevestiging slechts een aanbetaling van 25% vereist"
                    },
                    paymentSucceeded: {
                        en: "Payment succeeded!",
                        fr: "Paiement r\xe9ussi\xa0!",
                        es: "\xa1Pago exitoso!",
                        nl: "Betaling gelukt!"
                    },
                    skip: {
                        en: "Skip paying with card",
                        fr: "\xc9vitez de payer par carte",
                        es: "Evita pagar con tarjeta",
                        nl: "Betalen met kaart overslaan"
                    },
                    skipNote: {
                        en: "If you choose to skip paying with a card, we will contact you to discuss the payment method and other details.",
                        fr: "Si vous choisissez de ne pas payer avec une carte, nous vous contacterons pour discuter du mode de paiement et d'autres d\xe9tails.",
                        es: "Si elige omitir el pago con tarjeta, nos comunicaremos con usted para analizar el m\xe9todo de pago y otros detalles.",
                        nl: "Als u ervoor kiest om het betalen met een kaart over te slaan, nemen wij contact met u op om de betaalmethode en andere details te bespreken."
                    },
                    processingPaymentWarning: {
                        en: "Your payment is being processed. Are you sure you want to leave? This may result in a payment without a confirmed reservation.",
                        fr: "Votre paiement est en cours de traitement. \xcates-vous s\xfbr de vouloir partir? Cela peut entra\xeener un paiement sans r\xe9servation confirm\xe9e.",
                        es: "Su pago se est\xe1 procesando. \xbfEst\xe1s seguro de que quieres irte? Esto puede resultar en un pago sin una reserva confirmada.",
                        nl: "Uw betaling wordt verwerkt. Weet u zeker dat u wilt vertrekken? Dit kan resulteren in een betaling zonder bevestigde reservering."
                    },
                    reservationFailed: {
                        en: "Processing Your Booking",
                        fr: "Traitement de votre r\xe9servation",
                        es: "Procesando su reserva",
                        nl: "Uw boeking verwerken"
                    },
                    reservationFailedMessage: {
                        en: "We encountered an issue creating your reservation. Please try again.",
                        fr: "Nous avons rencontr\xe9 un probl\xe8me lors de la cr\xe9ation de votre r\xe9servation. Veuillez r\xe9essayer.",
                        es: "Encontramos un problema al crear su reserva. Por favor, int\xe9ntelo de nuevo.",
                        nl: "We zijn een probleem tegengekomen bij het maken van uw reservering. Probeer het alstublieft opnieuw."
                    },
                    paymentSucceededNote: {
                        en: "Good news: Your payment was successful. We can try creating your reservation again.",
                        fr: "Bonne nouvelle : votre paiement a \xe9t\xe9 effectu\xe9 avec succ\xe8s. Nous pouvons essayer de cr\xe9er \xe0 nouveau votre r\xe9servation.",
                        es: "Buenas noticias: Su pago fue exitoso. Podemos intentar crear su reserva nuevamente.",
                        nl: "Goed nieuws: uw betaling is gelukt. We kunnen proberen uw reservering opnieuw aan te maken."
                    },
                    retryReservation: {
                        en: "Retry Reservation",
                        fr: "R\xe9essayer la r\xe9servation",
                        es: "Reintentar reserva",
                        nl: "Reservering opnieuw proberen"
                    },
                    connectionTimeout: {
                        en: "Connection Timeout",
                        fr: "D\xe9lai de connexion d\xe9pass\xe9",
                        es: "Tiempo de espera de conexi\xf3n",
                        nl: "Verbindingstime-out"
                    },
                    connectionTimeoutMessage: {
                        en: "This is usually a temporary network issue. Please check your internet connection and try again.",
                        fr: "Il s'agit g\xe9n\xe9ralement d'un probl\xe8me de r\xe9seau temporaire. Veuillez v\xe9rifier votre connexion Internet et r\xe9essayer.",
                        es: "Este suele ser un problema de red temporal. Verifique su conexi\xf3n a Internet e intente nuevamente.",
                        nl: "Dit is meestal een tijdelijk netwerkprobleem. Controleer uw internetverbinding en probeer het opnieuw."
                    },
                    serverTimeout: {
                        en: "Server Timeout",
                        fr: "D\xe9lai du serveur d\xe9pass\xe9",
                        es: "Tiempo de espera del servidor",
                        nl: "Server time-out"
                    },
                    serverTimeoutMessage: {
                        en: "Our servers are taking longer than expected to respond. Please wait a few minutes and contact reservations@sxmsir.com if the issue persists.",
                        fr: "Nos serveurs mettent plus de temps que pr\xe9vu \xe0 r\xe9pondre. Veuillez patienter quelques minutes et contacter reservations@sxmsir.com si le probl\xe8me persiste.",
                        es: "Nuestros servidores tardan m\xe1s de lo esperado en responder. Espere unos minutos y comun\xedquese con reservations@sxmsir.com si el problema persiste.",
                        nl: "Onze servers doen er langer over dan verwacht om te reageren. Wacht een paar minuten en neem contact op met reservations@sxmsir.com als het probleem aanhoudt."
                    },
                    rateLimitTitle: {
                        en: "Please Wait",
                        fr: "S'il vous pla\xeet, attendez",
                        es: "Por favor espera",
                        nl: "Even geduld"
                    },
                    rateLimitMessage: {
                        en: "Please wait a moment and try again. We received too many requests in a short time.",
                        fr: "Veuillez patienter un instant et r\xe9essayer. Nous avons re\xe7u trop de demandes en peu de temps.",
                        es: "Espere un momento e intente nuevamente. Recibimos demasiadas solicitudes en poco tiempo.",
                        nl: "Wacht even en probeer het opnieuw. We ontvingen te veel verzoeken in korte tijd."
                    },
                    referenceId: {
                        en: "Reference ID",
                        fr: "ID de r\xe9f\xe9rence",
                        es: "ID de referencia",
                        nl: "Referentie-ID"
                    },
                    datesUnavailable: {
                        en: "Dates No Longer Available",
                        fr: "Dates plus disponibles",
                        es: "Fechas ya no disponibles",
                        nl: "Data niet meer beschikbaar"
                    },
                    datesUnavailableMessage: {
                        en: "The selected dates are no longer available for booking. Please choose different dates and try again.",
                        fr: "Les dates s\xe9lectionn\xe9es ne sont plus disponibles pour la r\xe9servation. Veuillez choisir des dates diff\xe9rentes et r\xe9essayer.",
                        es: "Las fechas seleccionadas ya no est\xe1n disponibles para reservar. Por favor, elija fechas diferentes e intente nuevamente.",
                        nl: "De geselecteerde data zijn niet meer beschikbaar voor boeking. Kies alstublieft andere data en probeer het opnieuw."
                    },
                    validationError: {
                        en: "Required Fields Missing",
                        fr: "Champs obligatoires manquants",
                        es: "Campos obligatorios faltantes",
                        nl: "Verplichte velden ontbreken"
                    },
                    bookingConfirmation: {
                        en: "Booking Confirmation",
                        fr: "Confirmation de r\xe9servation",
                        es: "Confirmaci\xf3n de reserva",
                        nl: "Boekingsbevestiging"
                    },
                    propertyName: {
                        en: "Property",
                        fr: "Propri\xe9t\xe9",
                        es: "Propiedad",
                        nl: "Eigendom"
                    },
                    checkIn: {
                        en: "Check-in",
                        fr: "Arriv\xe9e",
                        es: "Entrada",
                        nl: "Inchecken"
                    },
                    checkOut: {
                        en: "Check-out",
                        fr: "D\xe9part",
                        es: "Salida",
                        nl: "Uitchecken"
                    },
                    totalPaid: {
                        en: "Total Paid",
                        fr: "Total pay\xe9",
                        es: "Total pagado",
                        nl: "Totaal betaald"
                    },
                    depositReserved: {
                        en: "Deposit Reserved",
                        fr: "D\xe9p\xf4t r\xe9serv\xe9",
                        es: "Dep\xf3sito reservado",
                        nl: "Aanbetaling gereserveerd"
                    },
                    depositNote: {
                        en: "(will be charged upon confirmation)",
                        fr: "(sera factur\xe9 lors de la confirmation)",
                        es: "(se cobrar\xe1 al confirmar)",
                        nl: "(wordt in rekening gebracht bij bevestiging)"
                    },
                    confirmationNumber: {
                        en: "Confirmation Number",
                        fr: "Num\xe9ro de confirmation",
                        es: "N\xfamero de confirmaci\xf3n",
                        nl: "Bevestigingsnummer"
                    },
                    emailSent: {
                        en: "A confirmation email has been sent to your email address.",
                        fr: "Un email de confirmation a \xe9t\xe9 envoy\xe9 \xe0 votre adresse email.",
                        es: "Se ha enviado un correo electr\xf3nico de confirmaci\xf3n a su direcci\xf3n de correo electr\xf3nico.",
                        nl: "Er is een bevestigingsmail verzonden naar uw e-mailadres."
                    }
                },
                popup: {
                    arrival: {
                        en: "Arrival",
                        fr: "Arriv\xe9e",
                        es: "Llegada",
                        nl: "Aankomst"
                    },
                    departure: {
                        en: "Departure",
                        fr: "D\xe9part",
                        es: "Partida",
                        nl: "Vertrek"
                    },
                    bedroom: {
                        en: "Bedroom",
                        fr: "Chambre \xe0 coucher",
                        es: "Dormitorio",
                        nl: "Slaapkamer"
                    },
                    guests: {
                        en: "Guests",
                        fr: "Invit\xe9s",
                        es: "Hu\xe9spedes",
                        nl: "Gasten"
                    },
                    bonuses: {
                        en: "Bonuses",
                        fr: "Bonus",
                        es: "Bonificaciones",
                        nl: "Bonussen"
                    },
                    freeNight: {
                        en: "Free Nights Bonus",
                        fr: "Bonus de nuits gratuites",
                        es: "Bono de Noches Gratis",
                        nl: "Gratis nachtenbonus"
                    },
                    total: {
                        en: "Total",
                        fr: "Total",
                        es: "Total",
                        nl: "Totaal"
                    },
                    coupon: {
                        en: "Coupon",
                        fr: "Coupon",
                        es: "Cup\xf3n",
                        nl: "Coupon"
                    },
                    applyCoupon: {
                        en: "Apply",
                        fr: "Appliquer",
                        es: "Aplicar",
                        nl: "Toepassen"
                    },
                    taxesFees: {
                        en: "Taxes and Fees",
                        fr: "Taxes et frais",
                        es: "Impuestos y honorarios",
                        nl: "Belastingen en heffingen"
                    },
                    finalPrice: {
                        en: "Final Price",
                        fr: "Prix final",
                        es: "Precio final",
                        nl: "Uiteindelijke prijs"
                    },
                    contact: {
                        en: "We will contact you, and upon receiving your confirmation, a 25% charge will be applied",
                        fr: "Nous vous contacterons et apr\xe8s confirmation, les frais ne seront que de 25\xa0%",
                        es: "Nos pondremos en contacto con usted y, al recibir su confirmaci\xf3n, se aplicar\xe1 un cargo del 25%",
                        nl: "Wij nemen contact met u op en na ontvangst van uw bevestiging wordt een bedrag van 25% in rekening gebracht"
                    },
                    oldPrice: {
                        en: "Old Price",
                        fr: "Ancien prix",
                        es: "Precio anterior",
                        nl: "Oude prijs"
                    },
                    subtotal: {
                        en: "Subtotal",
                        fr: "Sous-total",
                        es: "Subtotal",
                        nl: "Subtotaal"
                    },
                    night: {
                        en: "night",
                        fr: "nuit",
                        es: "noche",
                        nl: "nacht"
                    },
                    nights: {
                        en: "nights",
                        fr: "nuits",
                        es: "noches",
                        nl: "nachten"
                    },
                    free: {
                        en: "free",
                        fr: "gratuit",
                        es: "gratis",
                        nl: "vrij"
                    },
                    invalidCoupon: {
                        en: "Invalid Coupon",
                        fr: "Coupon invalide",
                        es: "Cup\xf3n no v\xe1lido",
                        nl: "Ongeldige kortingsbon"
                    },
                    networkError: {
                        en: "Network error. Please check your connection and try again.",
                        fr: "Erreur r\xe9seau. Veuillez v\xe9rifier votre connexion et r\xe9essayer.",
                        es: "Error de red. Verifique su conexi\xf3n e intente nuevamente.",
                        nl: "Netwerkfout. Controleer uw verbinding en probeer het opnieuw."
                    },
                    generalError: {
                        en: "Unable to apply coupon. Please try again.",
                        fr: "Impossible d'appliquer le coupon. Veuillez r\xe9essayer.",
                        es: "No se puede aplicar el cup\xf3n. Int\xe9ntalo de nuevo.",
                        nl: "Kan coupon niet toepassen. Probeer het opnieuw."
                    }
                },
                thankYou: {
                    title: {
                        en: "Thank you for booking with us!",
                        fr: "Merci d'avoir r\xe9serv\xe9 avec nous!",
                        es: "\xa1Gracias por reservar con nosotros!",
                        nl: "Bedankt voor uw boeking bij ons!"
                    },
                    subtitle: {
                        en: "Please tell our Guest Experience team more about your vacation plans.",
                        fr: "Veuillez informer notre \xe9quipe Exp\xe9rience client de vos projets de vacances.",
                        es: "Cu\xe9ntele a nuestro equipo de Experiencia del hu\xe9sped m\xe1s informaci\xf3n sobre sus planes de vacaciones.",
                        nl: "Vertel ons Guest Experience-team meer over uw vakantieplannen."
                    },
                    phoneNumber: {
                        en: "Phone Number",
                        fr: "Num\xe9ro de t\xe9l\xe9phone",
                        es: "N\xfamero de tel\xe9fono",
                        nl: "Telefoonnummer"
                    },
                    yes: {
                        en: "Yes",
                        fr: "Oui",
                        es: "S\xed",
                        nl: "Ja"
                    },
                    no: {
                        en: "No",
                        fr: "Non",
                        es: "No",
                        nl: "Nee"
                    },
                    unknown: {
                        en: "unknown",
                        fr: "inconnu",
                        es: "desconocido",
                        nl: "onbekend"
                    },
                    rentCar: {
                        en: "Do you need to rent a car?",
                        fr: "Avez-vous besoin de louer une voiture ?",
                        es: "\xbfNecesitas alquilar un coche?",
                        nl: "Moet u een auto huren?"
                    },
                    rentCarNote: {
                        en: "Should you choose to rent a car and transfer services through Sotheby's Realty, your car rental will be delivered to the villa for your convenience and sign-up will take place on arrival at the villa.",
                        fr: "Si vous choisissez de louer une voiture et des services de transfert via Sotheby's Realty, votre voiture de location sera livr\xe9e \xe0 la villa pour votre commodit\xe9 et l'inscription aura lieu \xe0 votre arriv\xe9e \xe0 la villa.",
                        es: "Si decide alquilar un coche y servicios de transferencia a trav\xe9s de Sotheby's Realty, el coche de alquiler se entregar\xe1 en la villa para su comodidad y el registro se realizar\xe1 a su llegada a la villa.",
                        nl: "Als u ervoor kiest om een auto en transferdiensten te huren via Sotheby's Realty, wordt uw huurauto voor uw gemak bij de villa afgeleverd en vindt de aanmelding plaats bij aankomst in de villa."
                    },
                    transport: {
                        en: "Do you need transporation from the airport?",
                        fr: "Avez-vous besoin d'un transport depuis l'a\xe9roport ?",
                        es: "\xbfNecesitas transporte desde el aeropuerto?",
                        nl: "Heeft u vervoer nodig vanaf het vliegveld?"
                    },
                    transportNote: {
                        en: "We provide a complimentary arrival transfer from the airport to your villa.",
                        fr: "Nous proposons un transfert gratuit \xe0 l'arriv\xe9e de l'a\xe9roport \xe0 votre villa.",
                        es: "Ofrecemos un traslado de llegada de cortes\xeda desde el aeropuerto a su villa.",
                        nl: "Wij bieden een gratis aankomsttransfer van de luchthaven naar uw villa."
                    },
                    assistance: {
                        en: "Would you like assistance planning activities to create your perfect itinerary?",
                        fr: "Souhaitez-vous de l’aide pour planifier des activit\xe9s afin de cr\xe9er votre itin\xe9raire parfait\xa0?",
                        es: "\xbfLe gustar\xeda recibir ayuda para planificar actividades y crear su itinerario perfecto?",
                        nl: "Wilt u hulp bij het plannen van activiteiten om uw perfecte reisschema samen te stellen?"
                    },
                    assistanceNote: {
                        en: "We provide a complimentary arrival transfer from the airport to your villa.",
                        fr: "Nous proposons un transfert gratuit \xe0 l'arriv\xe9e de l'a\xe9roport \xe0 votre villa.",
                        es: "Ofrecemos un traslado de llegada de cortes\xeda desde el aeropuerto a su villa.",
                        nl: "Wij bieden een gratis aankomsttransfer van de luchthaven naar uw villa."
                    },
                    food: {
                        en: "Would you like to have the villa pre-stocked with Food and Beverages prior to arrival?",
                        fr: "Souhaitez-vous que la villa soit pr\xe9-approvisionn\xe9e en nourriture et en boissons avant votre arriv\xe9e\xa0?",
                        es: "\xbfLe gustar\xeda tener la villa abastecida previamente con alimentos y bebidas antes de su llegada?",
                        nl: "Wilt u dat de villa voor aankomst wordt gevuld met eten en drinken?"
                    },
                    foodNote: {
                        en: "Do you need any restaurant recommendation or need help with the reservations?",
                        fr: "Avez-vous besoin d'une recommandation de restaurant ou d'aide pour les r\xe9servations ?",
                        es: "\xbfNecesitas alguna recomendaci\xf3n de restaurante o necesitas ayuda con las reservas?",
                        nl: "Heeft u een restaurantaanbeveling nodig of heeft u hulp nodig bij het reserveren?"
                    },
                    submit: {
                        en: "Submit to guest experience",
                        fr: "Soumettre \xe0 l'exp\xe9rience client",
                        es: "Enviar a la experiencia del hu\xe9sped",
                        nl: "Verzenden naar gastervaring"
                    }
                },
                skip: {
                    title1: {
                        en: "Thank you for your inquiry",
                        fr: "Merci pour votre demande",
                        es: "Gracias por su consulta",
                        nl: "Bedankt voor uw aanvraag"
                    },
                    title2: {
                        en: "Thank you for booking with us!",
                        fr: "Merci d'avoir r\xe9serv\xe9 avec nous!",
                        es: "\xa1Gracias por reservar con nosotros!",
                        nl: "Bedankt voor uw boeking bij ons!"
                    },
                    subtitle1: {
                        en: "Please check your email, we will respond within 24 to 48 hours",
                        fr: "Veuillez v\xe9rifier votre email, nous vous r\xe9pondrons dans les 24 \xe0 48 heures",
                        es: "Por favor revisa tu correo electr\xf3nico, te responderemos dentro de 24 a 48 horas",
                        nl: "Controleer uw e-mail, wij reageren binnen 24 tot 48 uur"
                    },
                    subtitle2: {
                        en: "Please check your email for your booking confirmation.",
                        fr: "Veuillez v\xe9rifier votre courrier \xe9lectronique pour votre confirmation de r\xe9servation.",
                        es: "Por favor revise su correo electr\xf3nico para confirmar su reserva.",
                        nl: "Controleer uw e-mail voor uw boekingsbevestiging."
                    },
                    questions: {
                        en: "If you have any questions or would like to already start planning your vacation feel free to reach out directly:",
                        fr: "Si vous avez des questions ou si vous souhaitez d\xe9j\xe0 commencer \xe0 planifier vos vacances, n'h\xe9sitez pas \xe0 nous contacter directement\xa0:",
                        es: "Si tiene alguna pregunta o desea comenzar a planificar sus vacaciones, no dude en comunicarse directamente:",
                        nl: "Als u vragen heeft of al wilt beginnen met het plannen van uw vakantie, neem dan gerust rechtstreeks contact op met:"
                    },
                    button: {
                        en: "visit our guest experience page",
                        fr: "visitez notre page exp\xe9rience client",
                        es: "visita nuestra p\xe1gina de experiencia del hu\xe9sped",
                        nl: "bezoek onze gastervaringspagina"
                    }
                }
            }
        },
        introduction: {
            back: {
                en: "Back",
                fr: "Dos",
                es: "Atr\xe1s",
                nl: "Rug"
            },
            renting: {
                en: "renting",
                fr: "location",
                es: "alquiler",
                nl: "huren"
            },
            askAbout: {
                en: "Ask me about",
                fr: "contactez-moi \xe0 propos de cette",
                es: "Preguntame sobre",
                nl: "Vraag me over"
            },
            readMore: {
                en: "Read More",
                fr: "En savoir plus",
                es: "Leer m\xe1s",
                nl: "Lees verder"
            },
            readLess: {
                en: "Read Less",
                fr: "Lire moins",
                es: "Leer menos",
                nl: "Lees minder"
            },
            buying: {
                en: "Buying",
                fr: "l'achat",
                es: "Comprar",
                nl: "Kopen"
            },
            options: {
                en: "Options",
                fr: "Possibilit\xe9s",
                es: "Opciones",
                nl: "Opties"
            },
            about: {
                en: "About",
                fr: "\xc0 propos",
                es: "Acerca de",
                nl: "Over"
            }
        },
        updates: {
            title: {
                en: "Updates",
                fr: "Mises \xe0 jour",
                es: "Actualizaciones",
                nl: "Updates"
            },
            documents: {
                en: "Documents Update",
                fr: "Mise \xe0 jour des documents",
                es: "Actualizaci\xf3n de documentos",
                nl: "Documenten bijwerken"
            }
        },
        gallery: {
            browse: {
                en: "browse photos and videos",
                fr: "parcourir les photos et les vid\xe9os",
                es: "buscar fotos y videos",
                nl: "door foto's en video's bladeren"
            },
            download: {
                en: "Download images",
                fr: "T\xe9l\xe9charger des images",
                es: "Descargar im\xe1genes",
                nl: "Afbeeldingen downloaden"
            },
            next: {
                en: "Next",
                fr: "Suivant",
                es: "Pr\xf3ximo",
                nl: "Volgende"
            },
            previous: {
                en: "Previous",
                fr: "Pr\xe9c\xe9dent",
                es: "Anterior",
                nl: "Vorig"
            }
        },
        details: {
            title: {
                en: "Sleeping Arrangements / Bathrooms",
                fr: "Couchages / Salles de bain",
                es: "Disposiciones para dormir/ba\xf1os",
                nl: "Slaapplaatsen / Badkamers"
            },
            bedroomOptions: {
                en: "See more bedroom options",
                fr: "Voir plus d'options de chambres",
                es: "Ver m\xe1s opciones de dormitorios",
                nl: "Bekijk meer slaapkameropties"
            },
            commonArea: {
                en: "Common areas",
                fr: "Espaces communs",
                es: "\xc1reas comunes",
                nl: "Gemeenschappelijke ruimtes"
            }
        },
        amenities: {
            title: {
                en: "Amenities Available to You",
                fr: "Commodit\xe9s \xe0 votre disposition",
                es: "Servicios disponibles para usted",
                nl: "Voorzieningen die voor u beschikbaar zijn"
            },
            bathrooms: {
                en: "Bathrooms",
                fr: "Salles de bains",
                es: "Ba\xf1os",
                nl: "Badkamers"
            },
            room: {
                en: "This room has",
                fr: "Cette chambre a",
                es: "Esta habitaci\xf3n tiene",
                nl: "Deze kamer heeft"
            },
            and: {
                en: "and",
                fr: "et",
                es: "y",
                nl: "En"
            },
            realEstateTitle: {
                en: "Details, Amenities and Features",
                fr: "D\xe9tails, commodit\xe9s et fonctionnalit\xe9s",
                es: "Detalles, comodidades y caracter\xedsticas",
                nl: "Details, voorzieningen en functies"
            },
            moreInformation: {
                en: "More Information",
                fr: "Plus d'information",
                es: "M\xe1s informaci\xf3n",
                nl: "Meer informatie"
            },
            listingDetails: {
                en: "Listing Details",
                fr: "D\xe9tails de l'annonce",
                es: "listado de detalles",
                nl: "Lijst details"
            },
            amentiesFeatures: {
                en: "Amenities and Features",
                fr: "Commodit\xe9s et fonctionnalit\xe9s",
                es: "Servicios y caracter\xedsticas",
                nl: "Voorzieningen en functies"
            },
            id: {
                en: "Property Id",
                fr: "Identifiant de la propri\xe9t\xe9",
                es: "Identificaci\xf3n de propiedad",
                nl: "Property-ID"
            },
            type: {
                en: "Property Type",
                fr: "Type de propri\xe9t\xe9",
                es: "tipo de propiedad",
                nl: "Eigendom type"
            },
            price: {
                en: "Listing Price",
                fr: "Prix d'inscription",
                es: "Precio de listado",
                nl: "Aanbiedingsprijs"
            },
            bedrooms: {
                en: "Bedrooms",
                fr: "Chambres",
                es: "Dormitorios",
                nl: "Slaapkamers"
            },
            baths: {
                en: "Full baths",
                fr: "Bains complets",
                es: "Ba\xf1os completos",
                nl: "Volledige baden"
            },
            estateTitle: {
                en: "About",
                fr: "\xc0 propos",
                es: "Acerca de",
                nl: "Over"
            },
            realEstateAmenitiesButton: {
                en: "SHOW ALL Details, Amenities and Features",
                fr: "AFFICHER TOUS D\xe9tails, commodit\xe9s et caract\xe9ristiques",
                es: "MOSTRAR TODOS Los detalles, comodidades y caracter\xedsticas",
                nl: "TOON ALLE details, voorzieningen en kenmerken"
            },
            collapse: {
                en: "collapse all AMENITIES AVAILABLE TO YOU",
                fr: "r\xe9duire toutes les COMMODIT\xc9S \xc0 VOTRE DISPOSITION",
                es: "colapsar todas LAS AMENIDADES DISPONIBLES PARA USTED",
                nl: "samenvouwen van alle VOORZIENINGEN DIE VOOR U BESCHIKBAAR ZIJN"
            },
            show: {
                en: "SHOW ALL",
                fr: "AFFICHER TOUT",
                es: "MOSTRAR TODO",
                nl: "TOON ALLES"
            },
            amenties: {
                en: "AMENITIES AVAILABLE TO YOU",
                fr: "COMMODIT\xc9S \xc0 VOTRE DISPOSITION",
                es: "AMENIDADES DISPONIBLES PARA USTED",
                nl: "VOORZIENINGEN DIE VOOR U BESCHIKBAAR ZIJN"
            },
            download: {
                en: "Download Amenities",
                fr: "T\xe9l\xe9charger les commodit\xe9s",
                es: "Descargar Servicios",
                nl: "Voorzieningen downloaden"
            }
        },
        availability: {
            title: {
                en: "Availability",
                fr: "Disponibilit\xe9",
                es: "Disponibilidad",
                nl: "Beschikbaarheid"
            },
            note: {
                en: "Add your travel dates for exact pricing.",
                fr: "Ajoutez vos dates de voyage pour obtenir les prix exacts.",
                es: "Agregue las fechas de su viaje para conocer el precio exacto.",
                nl: "Voeg uw reisdata toe voor exacte prijzen."
            },
            subscribe: {
                en: "Subscribe to iCal",
                fr: "Abonnez-vous \xe0 iCal",
                es: "Suscr\xedbete a iCal",
                nl: "Abonneer u op iCal"
            },
            clear: {
                en: "Clear",
                fr: "Clair",
                es: "Claro",
                nl: "Duidelijk"
            },
            clearDates: {
                en: "Clear the Dates",
                fr: "Effacer les dates",
                es: "Borrar las fechas",
                nl: "Wis de datums"
            },
            skip: {
                en: "Skip to",
                fr: "suivant",
                es: "Pasemos a",
                nl: "Ga naar"
            }
        },
        reviews: {
            title: {
                en: "Unrivaled lifestyles <br /> Unforgettable Memories",
                fr: "Des modes de vie in\xe9gal\xe9s<br /> Souvenirs inoubliables",
                es: "Estilos de vida inigualables<br /> Memorias inolvidables",
                nl: "Onge\xebvenaarde levensstijl<br /> Onvergetelijke herinneringen"
            },
            button: {
                en: "Load More Reviews",
                fr: "Charger plus d'avis",
                es: "Cargar m\xe1s rese\xf1as",
                nl: "Laad meer recensies"
            }
        },
        bonuses: {
            label: {
                en: "VACATION RENTALS IN ST. MARTIN / VACATION RENTALS IN ST. MAARTEN",
                fr: "LOCATIONS SAISONNI\xc8RES \xc0 SAINT. MARTIN / LOCATIONS SAISONNI\xc8RES \xc0 ST. MARTIN",
                es: "ALQUILERES DE VACACIONES EN ST. MARTIN / ALQUILERES DE VACACIONES EN ST. MARTIN",
                nl: "VAKANTIEWONINGEN IN ST. MARTIN / VAKANTIEWONINGEN IN ST. MAARTEN"
            },
            title: {
                en: "Your stay is tailored to your wishes",
                fr: "Votre s\xe9jour est adapt\xe9 \xe0 vos souhaits",
                es: "Su estancia se adapta a sus deseos",
                nl: "Uw verblijf wordt afgestemd op uw wensen"
            }
        },
        rentals: {
            title: {
                en: "Continue Your Search",
                fr: "Continuez votre recherche",
                es: "Contin\xfae su b\xfasqueda",
                nl: "Ga door met zoeken"
            },
            button: {
                en: "view all",
                fr: "Voir tout",
                es: "ver todo",
                nl: "Bekijk alles"
            }
        }
    };
    return translationData;
};
/* harmony default export */ var singlePropertyTranslation = (singlePropertyTranslations);

;// CONCATENATED MODULE: ./components/pages/single-property/StripeComponent/ErrorDisplay.js




// Get default translations for fallbacks
var defaultTranslations = singlePropertyTranslation();
var ErrorDisplay = /*#__PURE__*/ react.forwardRef(function(param, ref) {
    var error = param.error, translations = param.translations, locale = param.locale, paymentIntentId = param.paymentIntentId;
    var _$ref, _$ref1, _$ref2, _$ref3, _$ref4;
    if (!error) return null;
    // Access Next.js environment variable (NEXT_PUBLIC_ prefix makes it available client-side)
    // ESLint: process.env is injected by Next.js at build time and is always available
    /* eslint-disable no-undef */ var supportEmail = "reservations@sxmsir.com" || 0;
    /* eslint-enable no-undef */ var subject = encodeURIComponent("Booking Assistance Needed");
    // Include payment intent ID in support email if available
    var bodyText = paymentIntentId ? "Hello,\n\nI need assistance with my booking.\n\nPayment Reference: ".concat(paymentIntentId, "\n\nPlease help me complete my reservation.\n\nThank you") : "Hello,\n\nI need assistance with my booking.\n\nPlease help me complete my reservation.\n\nThank you";
    var body = encodeURIComponent(bodyText);
    var mailtoLink = "mailto:".concat(supportEmail, "?subject=").concat(subject, "&body=").concat(body);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: ref,
        className: (StripeComponent_styles_module_default()).error_display,
        role: "alert",
        "aria-live": "assertive",
        tabIndex: -1,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (StripeComponent_styles_module_default()).error_display__header,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (StripeComponent_styles_module_default()).error_display__icon,
                        "aria-hidden": "true"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        className: (StripeComponent_styles_module_default()).error_display__title,
                        children: error.title
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (StripeComponent_styles_module_default()).error_display__content,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (StripeComponent_styles_module_default()).error_display__message,
                        children: error.message
                    }),
                    error.type === "reservation_failed" && error.paymentSucceeded && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (StripeComponent_styles_module_default()).error_display__success_note,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (StripeComponent_styles_module_default()).error_display__success_text,
                            children: (translations === null || translations === void 0 ? void 0 : (_$ref = translations.paymentSucceededNote) === null || _$ref === void 0 ? void 0 : _$ref[locale]) || defaultTranslations.welcome.card.stripe.paymentSucceededNote[locale] || defaultTranslations.welcome.card.stripe.paymentSucceededNote.en
                        })
                    }),
                    !error.canRetry && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (StripeComponent_styles_module_default()).error_display__support,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (StripeComponent_styles_module_default()).error_display__support_text,
                                children: (translations === null || translations === void 0 ? void 0 : (_$ref1 = translations.supportText) === null || _$ref1 === void 0 ? void 0 : _$ref1[locale]) || defaultTranslations.welcome.card.stripe.supportText[locale] || defaultTranslations.welcome.card.stripe.supportText.en
                            }),
                            paymentIntentId && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: (StripeComponent_styles_module_default()).error_display__reference,
                                children: [
                                    (translations === null || translations === void 0 ? void 0 : (_$ref2 = translations.referenceId) === null || _$ref2 === void 0 ? void 0 : _$ref2[locale]) || ((_$ref3 = defaultTranslations.welcome.card.stripe.referenceId) === null || _$ref3 === void 0 ? void 0 : _$ref3[locale]) || ((_$ref4 = defaultTranslations.welcome.card.stripe.referenceId) === null || _$ref4 === void 0 ? void 0 : _$ref4.en) || "Reference ID",
                                    ": ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("code", {
                                        children: paymentIntentId
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: mailtoLink,
                                className: (StripeComponent_styles_module_default()).error_display__support_link,
                                children: supportEmail
                            })
                        ]
                    })
                ]
            })
        ]
    });
});
ErrorDisplay.displayName = "ErrorDisplay";
/* harmony default export */ var StripeComponent_ErrorDisplay = (ErrorDisplay);

// EXTERNAL MODULE: ./node_modules/@flareapp/js/dist/index.mjs
var dist = __webpack_require__(1556);
;// CONCATENATED MODULE: ./components/pages/single-property/StripeComponent/checkoutForm.js
















// Get default translations for fallbacks
var checkoutForm_defaultTranslations = singlePropertyTranslation();
// Timeout constants
var SUCCESS_MESSAGE_DURATION = 2000 // 2 seconds
;
var API_TIMEOUT = 60000 // 60 seconds
;
// Helper function to determine error type from error object
var determineErrorType = function(error, currentStep, translations, locale) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    // Stripe card errors (declined, insufficient funds, etc.)
    if ((error === null || error === void 0 ? void 0 : error.type) === "card_error" || (error === null || error === void 0 ? void 0 : error.type) === "validation_error") {
        var ref11;
        return {
            type: "payment_failed",
            title: (translations === null || translations === void 0 ? void 0 : (ref11 = translations.paymentFailed) === null || ref11 === void 0 ? void 0 : ref11[locale]) || checkoutForm_defaultTranslations.welcome.card.stripe.paymentFailed[locale] || checkoutForm_defaultTranslations.welcome.card.stripe.paymentFailed.en,
            message: error.message,
            canRetry: true
        };
    }
    // Payment-related errors (payment intent, confirmation)
    if ((error === null || error === void 0 ? void 0 : error.type) === "payment_failed" || currentStep === "payment") {
        var ref12, ref13;
        return {
            type: "payment_failed",
            title: (translations === null || translations === void 0 ? void 0 : (ref12 = translations.paymentFailed) === null || ref12 === void 0 ? void 0 : ref12[locale]) || checkoutForm_defaultTranslations.welcome.card.stripe.paymentFailed[locale] || checkoutForm_defaultTranslations.welcome.card.stripe.paymentFailed.en,
            message: error.message || (translations === null || translations === void 0 ? void 0 : (ref13 = translations.paymentFailedMessage) === null || ref13 === void 0 ? void 0 : ref13[locale]) || checkoutForm_defaultTranslations.welcome.card.stripe.paymentFailedMessage[locale] || checkoutForm_defaultTranslations.welcome.card.stripe.paymentFailedMessage.en,
            canRetry: true
        };
    }
    // Payment status unclear (confirmation succeeded but paymentIntent missing)
    if ((error === null || error === void 0 ? void 0 : error.type) === "payment_unclear") {
        var ref14, ref15;
        return {
            type: "payment_unclear",
            title: (translations === null || translations === void 0 ? void 0 : (ref14 = translations.paymentUnclear) === null || ref14 === void 0 ? void 0 : ref14[locale]) || checkoutForm_defaultTranslations.welcome.card.stripe.paymentUnclear[locale] || checkoutForm_defaultTranslations.welcome.card.stripe.paymentUnclear.en,
            message: (translations === null || translations === void 0 ? void 0 : (ref15 = translations.paymentUnclearMessage) === null || ref15 === void 0 ? void 0 : ref15[locale]) || checkoutForm_defaultTranslations.welcome.card.stripe.paymentUnclearMessage[locale] || checkoutForm_defaultTranslations.welcome.card.stripe.paymentUnclearMessage.en,
            canRetry: false
        };
    }
    // Reservation creation failures (after successful payment)
    if (currentStep === "reservation") {
        var ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23;
        return {
            type: "reservation_failed",
            title: (translations === null || translations === void 0 ? void 0 : (ref16 = translations.reservationFailed) === null || ref16 === void 0 ? void 0 : ref16[locale]) || ((ref17 = checkoutForm_defaultTranslations.welcome.card.stripe.reservationFailed) === null || ref17 === void 0 ? void 0 : ref17[locale]) || ((ref18 = checkoutForm_defaultTranslations.welcome.card.stripe.reservationFailed) === null || ref18 === void 0 ? void 0 : ref18.en) || (translations === null || translations === void 0 ? void 0 : (ref19 = translations.reservationPending) === null || ref19 === void 0 ? void 0 : ref19[locale]) || checkoutForm_defaultTranslations.welcome.card.stripe.reservationPending[locale] || checkoutForm_defaultTranslations.welcome.card.stripe.reservationPending.en,
            message: (translations === null || translations === void 0 ? void 0 : (ref20 = translations.reservationFailedMessage) === null || ref20 === void 0 ? void 0 : ref20[locale]) || ((ref21 = checkoutForm_defaultTranslations.welcome.card.stripe.reservationFailedMessage) === null || ref21 === void 0 ? void 0 : ref21[locale]) || ((ref22 = checkoutForm_defaultTranslations.welcome.card.stripe.reservationFailedMessage) === null || ref22 === void 0 ? void 0 : ref22.en) || (translations === null || translations === void 0 ? void 0 : (ref23 = translations.reservationPendingMessage) === null || ref23 === void 0 ? void 0 : ref23[locale]) || checkoutForm_defaultTranslations.welcome.card.stripe.reservationPendingMessage[locale] || checkoutForm_defaultTranslations.welcome.card.stripe.reservationPendingMessage.en,
            canRetry: true,
            paymentSucceeded: true
        };
    }
    // Booking conflict (409 Conflict - dates no longer available)
    if ((error === null || error === void 0 ? void 0 : (ref = error.response) === null || ref === void 0 ? void 0 : ref.status) === 409) {
        var ref24, ref25;
        return {
            type: "dates_unavailable",
            title: (translations === null || translations === void 0 ? void 0 : (ref24 = translations.datesUnavailable) === null || ref24 === void 0 ? void 0 : ref24[locale]) || checkoutForm_defaultTranslations.welcome.card.stripe.datesUnavailable[locale] || checkoutForm_defaultTranslations.welcome.card.stripe.datesUnavailable.en,
            message: (translations === null || translations === void 0 ? void 0 : (ref25 = translations.datesUnavailableMessage) === null || ref25 === void 0 ? void 0 : ref25[locale]) || checkoutForm_defaultTranslations.welcome.card.stripe.datesUnavailableMessage[locale] || checkoutForm_defaultTranslations.welcome.card.stripe.datesUnavailableMessage.en,
            canRetry: false
        };
    }
    // Network errors (timeout, connection issues)
    if ((error === null || error === void 0 ? void 0 : error.code) === "ECONNABORTED" || (error === null || error === void 0 ? void 0 : error.code) === "ETIMEDOUT" || (error === null || error === void 0 ? void 0 : error.code) === "ECONNREFUSED" || (error === null || error === void 0 ? void 0 : (ref1 = error.message) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase().includes("network")) || (error === null || error === void 0 ? void 0 : (ref2 = error.message) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase().includes("timeout"))) {
        var ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33;
        return {
            type: "network_timeout",
            title: (translations === null || translations === void 0 ? void 0 : (ref26 = translations.connectionTimeout) === null || ref26 === void 0 ? void 0 : ref26[locale]) || ((ref27 = checkoutForm_defaultTranslations.welcome.card.stripe.connectionTimeout) === null || ref27 === void 0 ? void 0 : ref27[locale]) || ((ref28 = checkoutForm_defaultTranslations.welcome.card.stripe.connectionTimeout) === null || ref28 === void 0 ? void 0 : ref28.en) || (translations === null || translations === void 0 ? void 0 : (ref29 = translations.networkError) === null || ref29 === void 0 ? void 0 : ref29[locale]) || checkoutForm_defaultTranslations.welcome.card.stripe.networkError[locale] || checkoutForm_defaultTranslations.welcome.card.stripe.networkError.en,
            message: (translations === null || translations === void 0 ? void 0 : (ref30 = translations.connectionTimeoutMessage) === null || ref30 === void 0 ? void 0 : ref30[locale]) || ((ref31 = checkoutForm_defaultTranslations.welcome.card.stripe.connectionTimeoutMessage) === null || ref31 === void 0 ? void 0 : ref31[locale]) || ((ref32 = checkoutForm_defaultTranslations.welcome.card.stripe.connectionTimeoutMessage) === null || ref32 === void 0 ? void 0 : ref32.en) || (translations === null || translations === void 0 ? void 0 : (ref33 = translations.networkErrorMessage) === null || ref33 === void 0 ? void 0 : ref33[locale]) || checkoutForm_defaultTranslations.welcome.card.stripe.networkErrorMessage[locale] || checkoutForm_defaultTranslations.welcome.card.stripe.networkErrorMessage.en,
            canRetry: true
        };
    }
    // Server timeouts (504 Gateway Timeout, 503 Service Unavailable)
    if ((error === null || error === void 0 ? void 0 : (ref3 = error.response) === null || ref3 === void 0 ? void 0 : ref3.status) === 504 || (error === null || error === void 0 ? void 0 : (ref4 = error.response) === null || ref4 === void 0 ? void 0 : ref4.status) === 503) {
        var ref34, ref35, ref36, ref37, ref38, ref39;
        return {
            type: "server_timeout",
            title: (translations === null || translations === void 0 ? void 0 : (ref34 = translations.serverTimeout) === null || ref34 === void 0 ? void 0 : ref34[locale]) || ((ref35 = checkoutForm_defaultTranslations.welcome.card.stripe.serverTimeout) === null || ref35 === void 0 ? void 0 : ref35[locale]) || ((ref36 = checkoutForm_defaultTranslations.welcome.card.stripe.serverTimeout) === null || ref36 === void 0 ? void 0 : ref36.en) || "Server Timeout",
            message: (translations === null || translations === void 0 ? void 0 : (ref37 = translations.serverTimeoutMessage) === null || ref37 === void 0 ? void 0 : ref37[locale]) || ((ref38 = checkoutForm_defaultTranslations.welcome.card.stripe.serverTimeoutMessage) === null || ref38 === void 0 ? void 0 : ref38[locale]) || ((ref39 = checkoutForm_defaultTranslations.welcome.card.stripe.serverTimeoutMessage) === null || ref39 === void 0 ? void 0 : ref39.en) || "Our servers are taking longer than expected to respond. Please wait a few minutes and contact support if the issue persists.",
            canRetry: false
        };
    }
    // Rate limiting (429 Too Many Requests)
    if ((error === null || error === void 0 ? void 0 : (ref5 = error.response) === null || ref5 === void 0 ? void 0 : ref5.status) === 429) {
        var ref40, ref41, ref42, ref43, ref44, ref45;
        return {
            type: "rate_limit",
            title: (translations === null || translations === void 0 ? void 0 : (ref40 = translations.rateLimitTitle) === null || ref40 === void 0 ? void 0 : ref40[locale]) || ((ref41 = checkoutForm_defaultTranslations.welcome.card.stripe.rateLimitTitle) === null || ref41 === void 0 ? void 0 : ref41[locale]) || ((ref42 = checkoutForm_defaultTranslations.welcome.card.stripe.rateLimitTitle) === null || ref42 === void 0 ? void 0 : ref42.en) || "Please Wait",
            message: (translations === null || translations === void 0 ? void 0 : (ref43 = translations.rateLimitMessage) === null || ref43 === void 0 ? void 0 : ref43[locale]) || ((ref44 = checkoutForm_defaultTranslations.welcome.card.stripe.rateLimitMessage) === null || ref44 === void 0 ? void 0 : ref44[locale]) || ((ref45 = checkoutForm_defaultTranslations.welcome.card.stripe.rateLimitMessage) === null || ref45 === void 0 ? void 0 : ref45.en) || "Please wait a moment and try again. We received too many requests in a short time.",
            canRetry: true
        };
    }
    // Validation errors (422 Unprocessable Entity - Laravel validation)
    if ((error === null || error === void 0 ? void 0 : (ref6 = error.response) === null || ref6 === void 0 ? void 0 : ref6.status) === 422) {
        var ref46, ref47, ref48, ref49, ref50, ref51, ref52, ref53, ref54, ref55, ref56, ref57, ref58, ref59, ref60, ref61, ref62, ref63, ref64, ref65, ref66, ref67, ref68, ref69, ref70, ref71, ref72, ref73, ref74, ref75, ref76, ref77, ref78, ref79, ref80;
        var validationErrors = ((ref46 = error.response) === null || ref46 === void 0 ? void 0 : (ref47 = ref46.data) === null || ref47 === void 0 ? void 0 : ref47.errors) || {};
        var fieldNames = Object.keys(validationErrors);
        // Helper to sanitize text for safe rendering - strips HTML tags and trims
        // Uses DOMParser when available (client-side) for ReDoS-safe parsing
        var sanitizeText = function(str) {
            if (typeof str !== "string") return "";
            if ( true && window.DOMParser) {
                var doc = new DOMParser().parseFromString(str, "text/html");
                return (doc.body.textContent || "").trim();
            }
            // Server-side fallback with simple character stripping (no regex)
            var result = "";
            var inTag = false;
            for(var i = 0; i < str.length; i++){
                if (str[i] === "<") inTag = true;
                else if (str[i] === ">") inTag = false;
                else if (!inTag) result += str[i];
            }
            return result.trim();
        };
        // Helper to safely get translation string, sanitize it, and remove trailing colon
        var getFieldLabel = function(translationValue, fallback) {
            if (typeof translationValue === "string") {
                return sanitizeText(translationValue.replace(":", ""));
            }
            return fallback;
        };
        // Translation path shortcuts - welcome.card is guaranteed in translation structure
        var formFields = translations === null || translations === void 0 ? void 0 : (ref48 = translations.welcome) === null || ref48 === void 0 ? void 0 : (ref49 = ref48.card) === null || ref49 === void 0 ? void 0 : (ref50 = ref49.form) === null || ref50 === void 0 ? void 0 : ref50.fields;
        var defaultFormFields = checkoutForm_defaultTranslations.welcome.card.form.fields;
        var popup = translations === null || translations === void 0 ? void 0 : (ref51 = translations.welcome) === null || ref51 === void 0 ? void 0 : (ref52 = ref51.card) === null || ref52 === void 0 ? void 0 : ref52.popup;
        var defaultPopup = checkoutForm_defaultTranslations.welcome.card.popup;
        var card = translations === null || translations === void 0 ? void 0 : (ref53 = translations.welcome) === null || ref53 === void 0 ? void 0 : ref53.card;
        var defaultCard = checkoutForm_defaultTranslations.welcome.card;
        // Strict whitelist of allowed field names from Laravel validation
        // Only these fields are displayed - unknown fields are silently ignored
        // This prevents XSS by never rendering arbitrary backend response data
        var fieldLabels = {
            firstName: getFieldLabel((formFields === null || formFields === void 0 ? void 0 : (ref54 = formFields.firstName) === null || ref54 === void 0 ? void 0 : ref54[locale]) || ((ref55 = defaultFormFields.firstName) === null || ref55 === void 0 ? void 0 : ref55[locale]), "First Name"),
            lastName: getFieldLabel((formFields === null || formFields === void 0 ? void 0 : (ref56 = formFields.lastName) === null || ref56 === void 0 ? void 0 : ref56[locale]) || ((ref57 = defaultFormFields.lastName) === null || ref57 === void 0 ? void 0 : ref57[locale]), "Last Name"),
            email: getFieldLabel((formFields === null || formFields === void 0 ? void 0 : (ref58 = formFields.email) === null || ref58 === void 0 ? void 0 : ref58[locale]) || ((ref59 = defaultFormFields.email) === null || ref59 === void 0 ? void 0 : ref59[locale]), "Email"),
            startDate: getFieldLabel((popup === null || popup === void 0 ? void 0 : (ref60 = popup.arrival) === null || ref60 === void 0 ? void 0 : ref60[locale]) || ((ref61 = defaultPopup.arrival) === null || ref61 === void 0 ? void 0 : ref61[locale]), "Arrival Date"),
            endDate: getFieldLabel((popup === null || popup === void 0 ? void 0 : (ref62 = popup.departure) === null || ref62 === void 0 ? void 0 : ref62[locale]) || ((ref63 = defaultPopup.departure) === null || ref63 === void 0 ? void 0 : ref63[locale]), "Departure Date"),
            amount: getFieldLabel((card === null || card === void 0 ? void 0 : (ref64 = card.total) === null || ref64 === void 0 ? void 0 : ref64[locale]) || ((ref65 = defaultCard.total) === null || ref65 === void 0 ? void 0 : ref65[locale]), "Amount"),
            guests: getFieldLabel((card === null || card === void 0 ? void 0 : (ref66 = card.guests) === null || ref66 === void 0 ? void 0 : ref66[locale]) || ((ref67 = defaultCard.guests) === null || ref67 === void 0 ? void 0 : ref67[locale]), "Guests"),
            bedrooms: getFieldLabel((card === null || card === void 0 ? void 0 : (ref68 = card.bedrooms) === null || ref68 === void 0 ? void 0 : ref68[locale]) || ((ref69 = defaultCard.bedrooms) === null || ref69 === void 0 ? void 0 : ref69[locale]), "Bedrooms")
        };
        // Build user-friendly field list using only whitelisted fields
        // Uses hasOwnProperty to prevent prototype pollution attacks
        // Unknown fields from backend are ignored for security
        var friendlyFieldNames = fieldNames.filter(function(field) {
            return Object.prototype.hasOwnProperty.call(fieldLabels, field);
        }).map(function(field) {
            return fieldLabels[field];
        }).filter(function(label) {
            return typeof label === "string" && label.length > 0;
        }).join(", ");
        var formError = translations === null || translations === void 0 ? void 0 : (ref70 = translations.welcome) === null || ref70 === void 0 ? void 0 : (ref71 = ref70.card) === null || ref71 === void 0 ? void 0 : (ref72 = ref71.form) === null || ref72 === void 0 ? void 0 : ref72.error;
        var defaultFormError = checkoutForm_defaultTranslations.welcome.card.form.error;
        var stripe = translations === null || translations === void 0 ? void 0 : (ref73 = translations.welcome) === null || ref73 === void 0 ? void 0 : (ref74 = ref73.card) === null || ref74 === void 0 ? void 0 : ref74.stripe;
        var defaultStripe = checkoutForm_defaultTranslations.welcome.card.stripe;
        var baseMessage = (formError === null || formError === void 0 ? void 0 : (ref75 = formError.requiredFields) === null || ref75 === void 0 ? void 0 : ref75[locale]) || ((ref76 = defaultFormError.requiredFields) === null || ref76 === void 0 ? void 0 : ref76[locale]) || ((ref77 = defaultFormError.requiredFields) === null || ref77 === void 0 ? void 0 : ref77.en) || "Please fill in the following required fields";
        // Handle empty field names case (all fields were unknown/not whitelisted)
        // Note: We intentionally do NOT fall back to error.response?.data?.message
        // as it may contain sensitive backend details or stack traces
        var message = friendlyFieldNames.length > 0 ? "".concat(sanitizeText(baseMessage), ": ").concat(friendlyFieldNames) : sanitizeText(baseMessage) || "Please check your input and try again";
        return {
            type: "validation_error",
            title: (stripe === null || stripe === void 0 ? void 0 : (ref78 = stripe.validationError) === null || ref78 === void 0 ? void 0 : ref78[locale]) || ((ref79 = defaultStripe.validationError) === null || ref79 === void 0 ? void 0 : ref79[locale]) || ((ref80 = defaultStripe.validationError) === null || ref80 === void 0 ? void 0 : ref80.en) || "Required Fields Missing",
            message: message,
            canRetry: true
        };
    }
    // Default unknown error
    return {
        type: "unknown_error",
        title: (translations === null || translations === void 0 ? void 0 : (ref7 = translations.unknownError) === null || ref7 === void 0 ? void 0 : ref7[locale]) || ((ref8 = checkoutForm_defaultTranslations.welcome.card.stripe.unknownError) === null || ref8 === void 0 ? void 0 : ref8[locale]) || ((ref9 = checkoutForm_defaultTranslations.welcome.card.stripe.unknownError) === null || ref9 === void 0 ? void 0 : ref9.en) || "Something Went Wrong",
        message: error.message || (translations === null || translations === void 0 ? void 0 : (ref10 = translations.unknownErrorMessage) === null || ref10 === void 0 ? void 0 : ref10[locale]) || checkoutForm_defaultTranslations.welcome.card.stripe.unknownErrorMessage[locale] || checkoutForm_defaultTranslations.welcome.card.stripe.unknownErrorMessage.en,
        canRetry: false
    };
};
var CheckoutForm = function(param) {
    var total = param.total, propertyId = param.propertyId, listingId = param.listingId, startDate = param.startDate, endDate = param.endDate, bedrooms = param.bedrooms, email = param.email, firstName = param.firstName, lastName = param.lastName, setPlans = param.setPlans, guests = param.guests, setReservationId = param.setReservationId, propertyName = param.propertyName, coupon = param.coupon, setSkip = param.setSkip, bonuses = param.bonuses, freeNights = param.freeNights, freeNightlyRate = param.freeNightlyRate, initialPrice = param.initialPrice, translations = param.translations, _manually_blocked = param.manually_blocked, manually_blocked = _manually_blocked === void 0 ? false : _manually_blocked, _status = param.status, status = _status === void 0 ? "pending" : _status, setReservationData = param.setReservationData;
    var ref, ref1, ref2, ref3;
    var ref4 = (0,react.useState)(null), message = ref4[0], setMessage = ref4[1];
    var ref5 = (0,react.useState)(false), paymentDone = ref5[0], setPaymentDone = ref5[1];
    // Enhanced submission state for progress tracking and duplicate prevention
    var ref6 = (0,react.useState)({
        isSubmitting: false,
        currentStep: null,
        canRetry: false,
        error: null
    }), submissionState = ref6[0], setSubmissionState = ref6[1];
    // Refs to store timeout IDs for cleanup
    var successTimeoutRef = (0,react.useRef)(null);
    var errorTimeoutRef = (0,react.useRef)(null);
    // Ref to prevent race conditions in duplicate submission check
    var isSubmittingRef = (0,react.useRef)(false);
    // Ref to track component mount state to prevent state updates on unmounted component
    var isMountedRef = (0,react.useRef)(true);
    // Ref for error display to manage focus for accessibility
    var errorRef = (0,react.useRef)(null);
    var stripe = (0,react_stripe_umd.useStripe)();
    var elements = (0,react_stripe_umd.useElements)();
    var router = (0,next_router.useRouter)();
    // Cleanup timeouts on component unmount
    (0,react.useEffect)(function() {
        return function() {
            isMountedRef.current = false;
            if (successTimeoutRef.current) {
                clearTimeout(successTimeoutRef.current);
            }
            if (errorTimeoutRef.current) {
                clearTimeout(errorTimeoutRef.current);
            }
        };
    }, []);
    // Focus error display when error occurs for accessibility
    (0,react.useEffect)(function() {
        if (submissionState.error && errorRef.current) {
            errorRef.current.focus();
        }
    }, [
        submissionState.error
    ]);
    // Prevent accidental navigation during payment processing
    (0,react.useEffect)(function() {
        var handleBeforeUnload = function(e) {
            if (isSubmittingRef.current) {
                var ref;
                var message = (translations === null || translations === void 0 ? void 0 : (ref = translations.processingPaymentWarning) === null || ref === void 0 ? void 0 : ref[router.locale]) || checkoutForm_defaultTranslations.welcome.card.stripe.processingPaymentWarning[router.locale] || checkoutForm_defaultTranslations.welcome.card.stripe.processingPaymentWarning.en;
                e.preventDefault();
                e.returnValue = message // Standard for most browsers
                ;
                return message // For some older browsers
                ;
            }
        };
        window.addEventListener("beforeunload", handleBeforeUnload);
        return function() {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, [
        router.locale,
        translations
    ]);
    if (!stripe || !elements) {
        var ref7;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (StripeComponent_styles_module_default()).payment_form,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(elements_ProgressIndicator, {
                currentStep: "loading",
                message: (translations === null || translations === void 0 ? void 0 : (ref7 = translations.loadingPayment) === null || ref7 === void 0 ? void 0 : ref7[router.locale]) || "Loading payment form..."
            })
        });
    }
    // Helper function to get step message based on current step
    var getStepMessage = function(step) {
        var ref, ref1, ref2, ref3, ref4;
        var messages = {
            calculating: (translations === null || translations === void 0 ? void 0 : (ref = translations.calculating) === null || ref === void 0 ? void 0 : ref[router.locale]) || "Calculating...",
            payment: (translations === null || translations === void 0 ? void 0 : (ref1 = translations.processingPayment) === null || ref1 === void 0 ? void 0 : ref1[router.locale]) || "Processing payment...",
            reservation: (translations === null || translations === void 0 ? void 0 : (ref2 = translations.creatingReservation) === null || ref2 === void 0 ? void 0 : ref2[router.locale]) || "Creating reservation...",
            confirmation: (translations === null || translations === void 0 ? void 0 : (ref3 = translations.sendingConfirmation) === null || ref3 === void 0 ? void 0 : ref3[router.locale]) || "Sending confirmation..."
        };
        return messages[step] || (translations === null || translations === void 0 ? void 0 : (ref4 = translations.confirming) === null || ref4 === void 0 ? void 0 : ref4[router.locale]) || "Processing...";
    };
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(e) {
            var randomId, idempotencyKey, paymentIntentId, ref, _$error, paymentMethod, paymentError, id, intentResponse, ref1, intentError, clientKey, customerId, validationError, confirmation, confirmationError, supportEmail, unclearError, reservationResponse, capturedPaymentIntentId, errorInfo;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e.preventDefault();
                        // Clear any existing timeouts from previous submissions FIRST to prevent race conditions
                        if (successTimeoutRef.current) {
                            clearTimeout(successTimeoutRef.current);
                            successTimeoutRef.current = null;
                        }
                        if (errorTimeoutRef.current) {
                            clearTimeout(errorTimeoutRef.current);
                            errorTimeoutRef.current = null;
                        }
                        if (!isSubmittingRef.current) {
                            _ctx.next = 5;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 5:
                        isSubmittingRef.current = true;
                        randomId = (0,index_browser/* nanoid */.x0)(8) // 8 characters, cryptographically secure
                        ;
                        idempotencyKey = "booking-".concat(propertyId, "-").concat(Date.now(), "-").concat(randomId);
                        // Initialize submission state
                        setSubmissionState({
                            isSubmitting: true,
                            currentStep: "calculating",
                            canRetry: false,
                            error: null
                        });
                        paymentIntentId = null;
                        _ctx.prev = 10;
                        // Step 1: Price calculation
                        setSubmissionState(function(prev) {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                currentStep: "calculating"
                            });
                        });
                        _ctx.next = 14;
                        return axios/* default.post */.Z.post("reservation/price-calculation", {
                            lang: router.locale,
                            id: propertyId,
                            total: Math.round((total || 0) * 100),
                            startDate: startDate,
                            endDate: endDate,
                            bedrooms: bedrooms
                        }, {
                            timeout: API_TIMEOUT,
                            headers: {
                                "Idempotency-Key": idempotencyKey
                            }
                        });
                    case 14:
                        // Step 2: Create payment method and process payment
                        setSubmissionState(function(prev) {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                currentStep: "payment"
                            });
                        });
                        _ctx.next = 17;
                        return stripe.createPaymentMethod({
                            type: "card",
                            card: elements.getElement(react_stripe_umd.CardElement)
                        });
                    case 17:
                        ref = _ctx.sent;
                        _$error = ref.error;
                        paymentMethod = ref.paymentMethod;
                        if (!_$error) {
                            _ctx.next = 25;
                            break;
                        }
                        paymentError = new Error(_$error.message);
                        paymentError.type = "payment_failed";
                        paymentError.original = _$error;
                        throw paymentError;
                    case 25:
                        id = paymentMethod.id;
                        _ctx.next = 28;
                        return axios/* default.post */.Z.post("reservation/payment-intent", {
                            amount: Math.round((total || 0) * 100),
                            firstName: firstName,
                            lastName: lastName,
                            email: email
                        }, {
                            timeout: API_TIMEOUT,
                            headers: {
                                "Idempotency-Key": "".concat(idempotencyKey, "-intent")
                            }
                        });
                    case 28:
                        intentResponse = _ctx.sent;
                        if (!(intentResponse.status < 200 || intentResponse.status >= 300)) {
                            _ctx.next = 34;
                            break;
                        }
                        ;
                        intentError = new Error(((ref1 = intentResponse.data) === null || ref1 === void 0 ? void 0 : ref1.message) || "Failed to create payment intent");
                        intentError.type = "payment_failed";
                        throw intentError;
                    case 34:
                        clientKey = intentResponse.data[0];
                        paymentIntentId = intentResponse.data[1];
                        customerId = intentResponse.data[2];
                        if (!(!clientKey || !paymentIntentId || !customerId)) {
                            _ctx.next = 42;
                            break;
                        }
                        validationError = new Error("Invalid payment intent response: missing required fields");
                        validationError.type = "payment_failed";
                        validationError.details = {
                            hasClientKey: !!clientKey,
                            hasPaymentIntentId: !!paymentIntentId,
                            hasCustomerId: !!customerId
                        };
                        throw validationError;
                    case 42:
                        _ctx.next = 44;
                        return stripe.confirmCardPayment(clientKey, {
                            payment_method: {
                                card: elements.getElement(react_stripe_umd.CardElement),
                                billing_details: {
                                    name: firstName + " " + lastName
                                }
                            }
                        });
                    case 44:
                        confirmation = _ctx.sent;
                        if (confirmation.paymentIntent) {
                            _ctx.next = 59;
                            break;
                        }
                        if (!confirmation.error) {
                            _ctx.next = 53;
                            break;
                        }
                        confirmationError = new Error(confirmation.error.message);
                        confirmationError.type = "payment_failed";
                        confirmationError.original = confirmation.error;
                        throw confirmationError;
                    case 53:
                        // Payment may have succeeded but we lost connection or got unclear response
                        // DO NOT allow retry to prevent double charges
                        // Log to Flare with full transaction context for manual reconciliation
                        dist/* flare.report */.v.report(new Error("Payment Status Unclear - Manual Reconciliation Required"), {
                            context: {
                                paymentIntentId: paymentIntentId,
                                customerId: customerId,
                                propertyId: propertyId,
                                listingId: listingId,
                                propertyName: propertyName,
                                amount: Math.round((total || 0) * 100),
                                amountFormatted: total,
                                startDate: startDate,
                                endDate: endDate,
                                bedrooms: bedrooms,
                                guests: guests,
                                email: email,
                                firstName: firstName,
                                lastName: lastName,
                                idempotencyKey: idempotencyKey,
                                locale: router.locale
                            },
                            severity: "critical",
                            message: "Payment confirmation failed to return paymentIntent. Customer may have been charged. PaymentIntentId: ".concat(paymentIntentId, ". Support should check Stripe dashboard and contact customer at ").concat(email, ".")
                        });
                        supportEmail = "reservations@sxmsir.com" || 0;
                        unclearError = new Error("Payment status unclear. Reference ID: ".concat(paymentIntentId, ". Please contact support at ").concat(supportEmail, " with this reference ID."));
                        unclearError.type = "payment_unclear";
                        unclearError.paymentIntentId = paymentIntentId;
                        throw unclearError;
                    case 59:
                        // Step 5: Create reservation
                        setSubmissionState(function(prev) {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                currentStep: "reservation"
                            });
                        });
                        _ctx.next = 62;
                        return axios/* default.post */.Z.post("reservation/guesty", {
                            firstName: firstName,
                            lastName: lastName,
                            email: email,
                            startDate: startDate,
                            endDate: endDate,
                            propertyId: propertyId,
                            listingId: listingId,
                            amount: Math.round((total || 0) * 100),
                            paymentIntentId: paymentIntentId,
                            customerId: customerId,
                            bedrooms: bedrooms,
                            coupon: coupon,
                            id: id,
                            guests: guests,
                            bonuses: bonuses,
                            freeNights: freeNights,
                            freeNightlyRate: Math.round((freeNightlyRate || 0) * 100),
                            initialPrice: Math.round((initialPrice || 0) * 100),
                            manually_blocked: manually_blocked
                        }, {
                            timeout: API_TIMEOUT,
                            headers: {
                                "Idempotency-Key": "".concat(idempotencyKey, "-reservation")
                            }
                        });
                    case 62:
                        reservationResponse = _ctx.sent;
                        // Step 6: Success - backend sends confirmation email
                        setSubmissionState(function(prev) {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                currentStep: "confirmation"
                            });
                        });
                        // Success! Reset state and show success message
                        if (isMountedRef.current) {
                            setSubmissionState({
                                isSubmitting: false,
                                currentStep: null,
                                canRetry: false,
                                error: null
                            });
                            setMessage(translations === null || translations === void 0 ? void 0 : translations.paymentSucceeded[router.locale]);
                            setPaymentDone(true);
                            // Store full reservation data for confirmation display
                            setReservationId(reservationResponse.data.reservationId);
                            // Store reservation details if setReservationData prop is provided
                            if (typeof setReservationData === "function") {
                                setReservationData(reservationResponse.data.reservation);
                            }
                            successTimeoutRef.current = setTimeout(function() {
                                if (isMountedRef.current) {
                                    setMessage(null);
                                    setPlans("thankYou");
                                }
                            }, SUCCESS_MESSAGE_DURATION);
                        }
                        _ctx.next = 80;
                        break;
                    case 67:
                        _ctx.prev = 67;
                        _ctx.t0 = _ctx["catch"](10);
                        capturedPaymentIntentId = paymentIntentId || (_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.paymentIntentId) || null;
                        errorInfo = determineErrorType(_ctx.t0, submissionState.currentStep, translations, router.locale);
                        _ctx.prev = 71;
                        _ctx.next = 74;
                        return axios/* default.post */.Z.post("reservation/log-failed-attempt", {
                            propertyId: propertyId,
                            listingId: listingId,
                            propertyName: propertyName,
                            firstName: firstName,
                            lastName: lastName,
                            email: email,
                            startDate: startDate,
                            endDate: endDate,
                            bedrooms: bedrooms,
                            guests: guests,
                            amount: Math.round((total || 0) * 100),
                            amountFormatted: total,
                            coupon: coupon,
                            bonuses: bonuses,
                            freeNights: freeNights,
                            freeNightlyRate: Math.round((freeNightlyRate || 0) * 100),
                            initialPrice: Math.round((initialPrice || 0) * 100),
                            manually_blocked: manually_blocked,
                            paymentIntentId: capturedPaymentIntentId,
                            idempotencyKey: idempotencyKey,
                            failedStep: submissionState.currentStep,
                            errorType: errorInfo.type,
                            errorMessage: errorInfo.message,
                            locale: router.locale
                        }, {
                            timeout: 5000 // Short timeout - don't delay user feedback
                        });
                    case 74:
                        _ctx.next = 79;
                        break;
                    case 76:
                        _ctx.prev = 76;
                        _ctx.t1 = _ctx["catch"](71);
                        // Silently fail - logging shouldn't affect user experience
                        console.error("Failed to log payment attempt:", _ctx.t1);
                    case 79:
                        // Only update state if component is still mounted
                        if (isMountedRef.current) {
                            setSubmissionState({
                                isSubmitting: false,
                                currentStep: null,
                                canRetry: errorInfo.canRetry,
                                error: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, errorInfo), {
                                    paymentIntentId: capturedPaymentIntentId
                                })
                            });
                        }
                    case 80:
                        _ctx.prev = 80;
                        // Reset submission ref to allow retry if applicable
                        isSubmittingRef.current = false;
                        return _ctx.finish(80);
                    case 83:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    10,
                    67,
                    80,
                    83
                ],
                [
                    71,
                    76
                ]
            ]);
        }));
        return function handleSubmit(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                className: (StripeComponent_styles_module_default()).payment_form,
                onSubmit: handleSubmit,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_stripe_umd.CardElement, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                        variant: [
                            "color-accent",
                            "full-width"
                        ],
                        arrow: !submissionState.isSubmitting,
                        disabled: submissionState.isSubmitting || !stripe || !elements || paymentDone,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            id: "button-text",
                            children: submissionState.isSubmitting ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (StripeComponent_styles_module_default()).label,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(elements_ProgressIndicator, {
                                    currentStep: submissionState.currentStep,
                                    message: getStepMessage(submissionState.currentStep)
                                })
                            }) : submissionState.canRetry ? (translations === null || translations === void 0 ? void 0 : (ref = translations.tryAgain) === null || ref === void 0 ? void 0 : ref[router.locale]) || (translations === null || translations === void 0 ? void 0 : (ref1 = translations.confirm) === null || ref1 === void 0 ? void 0 : ref1[router.locale]) : translations === null || translations === void 0 ? void 0 : (ref2 = translations.confirm) === null || ref2 === void 0 ? void 0 : ref2[router.locale]
                        })
                    }),
                    message && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (StripeComponent_styles_module_default()).payment_message,
                        children: message
                    }),
                    submissionState.error && /*#__PURE__*/ (0,jsx_runtime.jsx)(StripeComponent_ErrorDisplay, {
                        ref: errorRef,
                        error: submissionState.error,
                        translations: translations,
                        locale: router.locale,
                        paymentIntentId: (ref3 = submissionState.error) === null || ref3 === void 0 ? void 0 : ref3.paymentIntentId
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: translations === null || translations === void 0 ? void 0 : translations.note[router.locale]
                        },
                        className: (StripeComponent_styles_module_default()).note
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (StripeComponent_styles_module_default()).skip,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                        variant: [
                            "label",
                            "xs"
                        ],
                        onClick: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                            return runtime_default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        _ctx.prev = 0;
                                        _ctx.next = 3;
                                        return axios/* default.post */.Z.post("email/skip-payment", {
                                            propertyId: propertyId,
                                            listingId: listingId,
                                            total: Math.round((total || 0) * 100),
                                            propertyName: propertyName,
                                            startDate: startDate,
                                            endDate: endDate,
                                            bedrooms: bedrooms,
                                            email: email,
                                            firstName: firstName,
                                            lastName: lastName,
                                            guests: guests,
                                            coupon: coupon,
                                            bonuses: bonuses,
                                            freeNights: freeNights,
                                            freeNightlyRate: Math.round((freeNightlyRate || 0) * 100),
                                            initialPrice: Math.round((initialPrice || 0) * 100),
                                            manually_blocked: manually_blocked,
                                            status: status
                                        });
                                    case 3:
                                        setMessage(null);
                                        setPlans("finish");
                                        setSkip(true);
                                        _ctx.next = 11;
                                        break;
                                    case 8:
                                        _ctx.prev = 8;
                                        _ctx.t0 = _ctx["catch"](0);
                                        console.error("Skip payment error:", _ctx.t0);
                                    case 11:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee, null, [
                                [
                                    0,
                                    8
                                ]
                            ]);
                        })),
                        children: translations === null || translations === void 0 ? void 0 : translations.skip[router.locale]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: translations === null || translations === void 0 ? void 0 : translations.skipNote[router.locale]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var checkoutForm = (CheckoutForm);

;// CONCATENATED MODULE: ./components/pages/single-property/StripeComponent/index.js








var options = {
};
var StripeComponent = function(props) {
    var ref = (0,react.useState)(null), stripe = ref[0], setStripe = ref[1];
    (0,react.useEffect)(function() {
        var fetchStripe = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var stripeInstance;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return (0,pure.loadStripe)(// eslint-disable-next-line no-undef
                            "pk_live_WIAkLmoBKTljfKkcGJEtTg3f");
                        case 2:
                            stripeInstance = _ctx.sent;
                            setStripe(stripeInstance);
                        case 4:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function fetchStripe() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchStripe();
    }, []);
    if (stripe) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_stripe_umd.Elements, {
            stripe: stripe,
            options: options,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(checkoutForm, (0,_object_spread/* default */.Z)({}, props))
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
        children: "Loading Payment Method..."
    });
};
/* harmony default export */ var single_property_StripeComponent = (StripeComponent);

// EXTERNAL MODULE: ./components/layout/Column/index.js
var Column = __webpack_require__(70539);
// EXTERNAL MODULE: ./components/layout/Columns/index.js
var Columns = __webpack_require__(40050);
// EXTERNAL MODULE: ./public/icons/icon-screenshots-prev.svg
var icon_screenshots_prev = __webpack_require__(36133);
// EXTERNAL MODULE: ./public/icons/icon-screenshots-next.svg
var icon_screenshots_next = __webpack_require__(80242);
// EXTERNAL MODULE: ./components/elements/SlickSlider/index.js + 2 modules
var SlickSlider = __webpack_require__(12817);
// EXTERNAL MODULE: ./components/pages/single-property/components/Card/components/Reservation/components/ModalContent/Details/styles.module.scss
var Details_styles_module = __webpack_require__(61825);
var Details_styles_module_default = /*#__PURE__*/__webpack_require__.n(Details_styles_module);
// EXTERNAL MODULE: ./components/elements/LazyImage/index.js
var LazyImage = __webpack_require__(20027);
// EXTERNAL MODULE: ./components/helpers/withComma.js
var withComma = __webpack_require__(29828);
;// CONCATENATED MODULE: ./components/pages/single-property/components/Card/components/Reservation/components/ModalContent/Details/index.js














var formatDate = function(date) {
    if (!date) return "";
    var d = moment_default()(date).utc();
    return d.format("MMM DD, YYYY");
};
var formatDateForAPI = function(date) {
    if (!date) return "";
    var d = moment_default()(date).utc();
    return d.format("YYYY-MM-DD");
};
var Details = function(param) {
    var property = param.property, startDate = param.startDate, endDate = param.endDate, bedrooms = param.bedrooms, guests = param.guests, setUpdatedPrice = param.setUpdatedPrice, updatedPrice = param.updatedPrice, setCoupon = param.setCoupon, totalWithoutStripe = param.totalWithoutStripe, taxesAndFees = param.taxesAndFees, totalCostPerNights = param.totalCostPerNights, bonuses = param.bonuses, numberOfFreeNights = param.numberOfFreeNights, freeNightsCost = param.freeNightsCost, freeNightsOldPrice = param.freeNightsOldPrice, translations = param.translations;
    var ref;
    var ref1 = (0,react.useState)(false), error = ref1[0], setError = ref1[1];
    var router = (0,next_router.useRouter)();
    // Memoize active bonuses to avoid filtering twice
    var activeBonuses = (0,react.useMemo)(function() {
        if (!bonuses) return [];
        return Object.keys(bonuses).filter(function(bonus) {
            return bonuses[bonus];
        });
    }, [
        bonuses
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Details_styles_module_default()).details,
        children: [
            property.pictures && /*#__PURE__*/ (0,jsx_runtime.jsx)(SlickSlider/* default */.Z, {
                nextArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_screenshots_next/* default */.Z, {}),
                prevArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_screenshots_prev/* default */.Z, {}),
                slidesToShow: 1,
                className: (Details_styles_module_default()).details__slider,
                children: property.pictures && property.pictures.slice(0, 7).map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyImage/* default */.Z, {
                        src: item.original,
                        index: true
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: (Details_styles_module_default()).details__title,
                children: property === null || property === void 0 ? void 0 : property.propertyTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,withModifiers/* withModifiers */.i)("details__row", [
                    "merged"
                ], (Details_styles_module_default())),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: translations.popup.arrival[router.locale]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: formatDate(startDate)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,withModifiers/* withModifiers */.i)("details__row", [
                    "merged"
                ], (Details_styles_module_default())),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: translations.popup.departure[router.locale]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: formatDate(endDate)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,withModifiers/* withModifiers */.i)("details__row", [
                    "merged"
                ], (Details_styles_module_default())),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: translations.popup.bedroom[router.locale]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (Details_styles_module_default()).details__bedroom,
                        children: bedrooms
                    })
                ]
            }),
            guests && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,withModifiers/* withModifiers */.i)("details__row", [
                    "merged"
                ], (Details_styles_module_default())),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: (ref = translations.popup) === null || ref === void 0 ? void 0 : ref.guests[router.locale]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: guests
                    })
                ]
            }),
            activeBonuses.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Details_styles_module_default()).details__row,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: translations.popup.bonuses[router.locale]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: activeBonuses.map(function(bonus, index, array) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    bonus === "night" && numberOfFreeNights && "".concat(numberOfFreeNights, " ").concat(translations.popup.free[router.locale], " "),
                                    bonus !== "night" && bonus.charAt(0).toUpperCase() + bonus.slice(1),
                                    bonus === "night" && (Number(numberOfFreeNights) > 1 ? translations.popup.nights[router.locale] : translations.popup.night[router.locale]),
                                    index !== array.length - 1 ? ", " : ""
                                ]
                            }, bonus);
                        })
                    })
                ]
            }),
            freeNightsOldPrice && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Details_styles_module_default()).details__row,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: translations.popup.subtotal[router.locale]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            "$",
                            (0,withComma/* withComma */.u)(freeNightsOldPrice)
                        ]
                    })
                ]
            }),
            freeNightsCost !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,withModifiers/* withModifiers */.i)("details__row", [
                    "merged"
                ], (Details_styles_module_default())),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: translations.popup.freeNight[router.locale]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            "- $",
                            (0,withComma/* withComma */.u)(freeNightsCost)
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Details_styles_module_default()).details__row,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: translations.popup.total[router.locale]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            "$",
                            (0,withComma/* withComma */.u)(totalCostPerNights)
                        ]
                    })
                ]
            }),
            updatedPrice && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,withModifiers/* withModifiers */.i)("details__row", [
                    "merged"
                ], (Details_styles_module_default())),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: translations.popup.coupon[router.locale]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            "- $",
                            (0,withComma/* withComma */.u)(updatedPrice.discount)
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,withModifiers/* withModifiers */.i)("details__row", [
                    "merged"
                ], (Details_styles_module_default())),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: translations.popup.taxesFees[router.locale]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            "+ $",
                            updatedPrice ? (0,withComma/* withComma */.u)(updatedPrice.tax10) : (0,withComma/* withComma */.u)(taxesAndFees)
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Details_styles_module_default()).details__row,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: translations.popup.finalPrice[router.locale]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            "$",
                            updatedPrice ? (0,withComma/* withComma */.u)(updatedPrice.totalWith10Taxes) : (0,withComma/* withComma */.u)(totalWithoutStripe)
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: translations.popup.contact[router.locale]
                },
                className: (Details_styles_module_default()).details__note
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Details_styles_module_default()).details__deposit_amount,
                children: [
                    "25% deposit: $",
                    updatedPrice ? (0,withComma/* withComma */.u)(Math.round(updatedPrice.totalWith10Taxes * 0.25)) : (0,withComma/* withComma */.u)(Math.round(totalWithoutStripe * 0.25))
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
                enableReinitialize: true,
                initialValues: {
                    coupon: ""
                },
                children: function(param) {
                    var values = param.values, setFieldValue = param.setFieldValue, handleBlur = param.handleBlur, isSubmitting = param.isSubmitting;
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, {
                        className: (Details_styles_module_default()).form,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                variant: [
                                    "full-width"
                                ],
                                maxLength: 30,
                                placeholder: translations.popup.coupon[router.locale],
                                name: "coupon",
                                onChange: function(e) {
                                    setFieldValue("coupon", e.target.value.replace(/[^a-zA-Z0-9]/g, ""));
                                },
                                onBlur: handleBlur,
                                className: (Details_styles_module_default()).form__field
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                                variant: [
                                    "secondary"
                                ],
                                className: (Details_styles_module_default()).form__button,
                                disabled: isSubmitting,
                                arrow: false,
                                "aria-label": translations.popup.applyCoupon[router.locale],
                                name: "apply-coupon-button",
                                onClick: function() {
                                    return axios/* default.post */.Z.post("reservation/price-calculation", {
                                        lang: router.locale,
                                        id: property === null || property === void 0 ? void 0 : property.resource_id,
                                        startDate: formatDateForAPI(startDate),
                                        endDate: formatDateForAPI(endDate),
                                        bedrooms: bedrooms,
                                        discountCode: values.coupon
                                    }).then(function(res) {
                                        var data = res.data;
                                        if (data.discount) {
                                            setUpdatedPrice(data);
                                            setCoupon(values.coupon);
                                            setError(false);
                                        } else {
                                            setError(true);
                                        }
                                    }).catch(function(error) {
                                        if (error.response) {
                                            setError(error.response.status);
                                        } else {
                                            setError("network");
                                        }
                                    });
                                },
                                children: translations.popup.applyCoupon[router.locale]
                            })
                        ]
                    });
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Details_styles_module_default()).form__error,
                children: [
                    error === 404 && translations.popup.invalidCoupon[router.locale],
                    error === "network" && translations.popup.networkError[router.locale],
                    error && error !== 404 && error !== "network" && error !== false && translations.popup.generalError[router.locale]
                ]
            })
        ]
    });
};
/* harmony default export */ var ModalContent_Details = (Details);

;// CONCATENATED MODULE: ./public/icons/icon-step-contact.svg
var icon_step_contact_path, icon_step_contact_path2, _path3, _path4;

function icon_step_contact_extends() { icon_step_contact_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return icon_step_contact_extends.apply(this, arguments); }



const SvgIconStepContact = props => /*#__PURE__*/react.createElement("svg", icon_step_contact_extends({
  width: 32,
  height: 32,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), icon_step_contact_path || (icon_step_contact_path = /*#__PURE__*/react.createElement("path", {
  d: "M.421 13.562h5.31a.421.421 0 0 0 .422-.422.418.418 0 0 0-.422-.422H.421A.42.42 0 0 0 0 13.14c0 .236.186.422.421.422ZM.421 7.847h5.31a.42.42 0 0 0 .422-.422.418.418 0 0 0-.422-.422H.421A.42.42 0 0 0 0 7.425c0 .236.186.422.421.422ZM.421 19.278h5.31a.421.421 0 0 0 .422-.422.418.418 0 0 0-.422-.422H.421a.42.42 0 0 0-.421.422c0 .236.186.422.421.422Z",
  fill: "#999"
})), icon_step_contact_path2 || (icon_step_contact_path2 = /*#__PURE__*/react.createElement("path", {
  d: "M28.003 0H6.653a4.004 4.004 0 0 0-3.997 4.002.42.42 0 1 0 .843 0A3.164 3.164 0 0 1 6.656.84h21.347c1.74 0 3.157 1.42 3.157 3.162v23.996a3.164 3.164 0 0 1-3.157 3.162H6.653a3.164 3.164 0 0 1-3.158-3.162.42.42 0 1 0-.843 0A4.005 4.005 0 0 0 6.648 32h21.355A4.005 4.005 0 0 0 32 27.998V4.002A4.004 4.004 0 0 0 28.003 0Z",
  fill: "#999"
})), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
  d: "M6.153 24.576a.42.42 0 0 0-.422-.423H.421a.418.418 0 0 0-.421.423c0 .235.186.422.421.422h5.314a.42.42 0 0 0 .422-.422h-.004Z",
  fill: "#999"
})), _path4 || (_path4 = /*#__PURE__*/react.createElement("path", {
  d: "M21.578 11.087a3.94 3.94 0 0 0-3.93-3.936 3.94 3.94 0 0 0-3.93 3.936 3.94 3.94 0 0 0 3.93 3.936 3.937 3.937 0 0 0 3.93-3.936Zm-7.016 0a3.092 3.092 0 0 1 3.086-3.091 3.092 3.092 0 0 1 0 6.183 3.092 3.092 0 0 1-3.086-3.092ZM23.494 17.208c-.851-.985-2.066-1.485-3.603-1.485a.386.386 0 0 0-.28.132l-.013-.012s-.744.703-1.946.703c-1.203 0-1.942-.695-1.947-.703l-.012.012a.411.411 0 0 0-.285-.132c-1.537 0-2.752.5-3.603 1.485-1.785 2.066-1.314 5.5-1.29 5.646a.42.42 0 0 0 .418.36h13.433a.426.426 0 0 0 .417-.36c.021-.145.492-3.58-1.289-5.646Zm-3.343-.637c1.157.05 2.066.451 2.707 1.188 1.223 1.415 1.194 3.729 1.132 4.614H11.31c-.066-.885-.095-3.19 1.128-4.614.636-.74 1.55-1.138 2.707-1.192.462.269 1.222.596 1.222.596a3.793 3.793 0 0 0 2.562 0s.736-.302 1.22-.596l.003.004Z",
  fill: "#B18D3B"
})));

/* harmony default export */ var icon_step_contact = (SvgIconStepContact);
;// CONCATENATED MODULE: ./public/icons/icon-step-payment.svg
var icon_step_payment_path, icon_step_payment_path2, icon_step_payment_path3;

function icon_step_payment_extends() { icon_step_payment_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return icon_step_payment_extends.apply(this, arguments); }



const SvgIconStepPayment = props => /*#__PURE__*/react.createElement("svg", icon_step_payment_extends({
  width: 32,
  height: 32,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), icon_step_payment_path || (icon_step_payment_path = /*#__PURE__*/react.createElement("path", {
  d: "m30.206 15.13-3.31-1.26V2.79c0-1.54-1.25-2.79-2.791-2.79H2.79C1.25 0 0 1.25 0 2.79v12.28c0 1.54 1.25 2.79 2.79 2.79h.58l-1.05 2.77c-.55 1.44.18 3.05 1.61 3.6l19.915 7.59c.32.12.66.18.99.18.39 0 .78-.08 1.14-.25.68-.31 1.2-.86 1.47-1.55l4.372-11.47c.55-1.44-.18-3.05-1.61-3.6ZM.8 15.06V2.79C.8 1.69 1.69.8 2.79.8h21.315c1.1 0 1.99.9 1.99 1.99v12.28c0 1.1-.89 1.99-1.99 1.99H2.79c-1.1 0-1.99-.9-1.99-1.99v-.01Zm28.996 6.73-10.332-3.94h4.64c.481 0 .931-.12 1.331-.34l5.231 1.99-.87 2.28v.01Zm-3.1 8.12c-.19.5-.56.89-1.05 1.11-.49.22-1.031.23-1.521.05L4.22 23.48a1.997 1.997 0 0 1-1.15-2.57l1.16-3.05h13.022s.03.02.05.03l12.213 4.65-2.81 7.38-.01-.01Zm4.37-11.47-.12.31-4.79-1.82c.45-.5.73-1.15.73-1.87v-.34l3.02 1.15c1.02.39 1.54 1.54 1.15 2.57h.01Z",
  fill: "#999"
})), icon_step_payment_path2 || (icon_step_payment_path2 = /*#__PURE__*/react.createElement("path", {
  d: "M3.572 10.74c-.22 0-.4.18-.4.4 0 .22.18.4.4.4h3.35c.22 0 .4-.18.4-.4 0-.22-.18-.4-.4-.4h-3.35ZM12.172 10.74h-3.35c-.22 0-.4.18-.4.4 0 .22.18.4.4.4h3.35c.22 0 .4-.18.4-.4 0-.22-.18-.4-.4-.4ZM17.426 10.74h-3.35c-.22 0-.4.18-.4.4 0 .22.18.4.4.4h3.35c.22 0 .4-.18.4-.4 0-.22-.18-.4-.4-.4ZM17.402 13.81h-3.35c-.22 0-.4.18-.4.4 0 .22.18.4.4.4h3.35c.22 0 .4-.18.4-.4 0-.22-.18-.4-.4-.4ZM22.664 10.74h-3.35c-.22 0-.4.18-.4.4 0 .22.18.4.4.4h3.35c.22 0 .4-.18.4-.4 0-.22-.18-.4-.4-.4ZM13.455 4.05h9.202c.22 0 .4-.18.4-.4 0-.22-.18-.4-.4-.4h-9.202c-.22 0-.4.18-.4.4 0 .22.18.4.4.4ZM23.047 6.72c0-.22-.18-.4-.4-.4h-9.192c-.22 0-.4.18-.4.4 0 .22.18.4.4.4h9.202c.22 0 .4-.18.4-.4h-.01ZM12.152 13.81H3.56c-.22 0-.4.18-.4.4 0 .22.18.4.4.4h8.592c.22 0 .4-.18.4-.4 0-.22-.18-.4-.4-.4ZM4.209 8.65h3.29c.58 0 1.05-.47 1.05-1.05V4.31c0-.58-.47-1.06-1.05-1.06H4.21c-.58 0-1.06.47-1.06 1.06V7.6c0 .58.47 1.05 1.06 1.05Zm-.25-4.34c0-.14.11-.26.26-.26h3.29c.14 0 .25.11.25.26V7.6c0 .14-.11.25-.25.25H4.22c-.14 0-.26-.11-.26-.25V4.31Z",
  fill: "#999"
})), icon_step_payment_path3 || (icon_step_payment_path3 = /*#__PURE__*/react.createElement("path", {
  d: "m8.299 19.37-1.38-.52a.399.399 0 0 0-.52.23c-.08.21.02.44.23.52l1.38.52s.1.03.14.03c.16 0 .31-.1.37-.26a.399.399 0 0 0-.23-.52h.01ZM11.318 20.54l-1.38-.52a.399.399 0 0 0-.52.23c-.08.21.02.44.23.52l1.38.52s.1.03.14.03c.16 0 .31-.1.37-.26a.399.399 0 0 0-.23-.52h.01ZM14.353 21.71l-1.38-.52a.399.399 0 0 0-.52.23c-.08.21.02.44.23.52l1.38.52s.1.03.14.03c.16 0 .31-.1.37-.26a.399.399 0 0 0-.23-.52h.01ZM23.597 22.09c-.48-.18-.98-.25-1.48-.2-.33-.36-.75-.65-1.23-.83-.82-.31-1.72-.29-2.531.07-.81.36-1.42 1.01-1.74 1.84a3.316 3.316 0 0 0 3.09 4.49c.1 0 .2 0 .3-.02.33.36.75.65 1.23.83.38.15.78.22 1.18.22.46 0 .92-.1 1.351-.29.81-.36 1.42-1.01 1.74-1.84.65-1.7-.21-3.62-1.91-4.27Zm-1.55 2.95a2.55 2.55 0 0 1-1.32 1.4c-.13.06-.26.1-.39.14a2.51 2.51 0 0 1-.26-2.28c.24-.62.71-1.12 1.32-1.4.13-.06.26-.1.39-.14.43.65.56 1.5.26 2.28Zm-3.231 1.45a2.514 2.514 0 0 1-1.45-3.24c.24-.62.71-1.12 1.32-1.4.33-.15.67-.22 1.02-.22.3 0 .6.05.89.17.21.08.4.19.58.32-.04.01-.07.03-.11.04-.81.36-1.42 1.01-1.74 1.84-.34.89-.26 1.84.13 2.64-.22-.02-.43-.07-.65-.15h.01Zm5.951-.41a2.55 2.55 0 0 1-1.32 1.4c-.61.27-1.29.29-1.92.05-.21-.08-.41-.19-.58-.32.04-.01.07-.03.11-.04.81-.36 1.42-1.01 1.74-1.84.34-.89.26-1.83-.12-2.63.22.02.43.06.64.14 1.29.49 1.94 1.94 1.45 3.24Z",
  fill: "#B18D3B"
})));

/* harmony default export */ var icon_step_payment = (SvgIconStepPayment);
// EXTERNAL MODULE: ./providers/ResponsiveContext.js
var ResponsiveContext = __webpack_require__(40670);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 24 modules
var es = __webpack_require__(98077);
;// CONCATENATED MODULE: ./components/pages/single-property/components/Card/components/Reservation/components/ModalContent/index.js
























// Helper component to sync updatedPrice with Formik's total field
// This is extracted to a separate component to properly use hooks
// (hooks cannot be called inside render props)
var FormTotalSync = function(param) {
    var updatedPrice = param.updatedPrice;
    var setFieldValue = (0,formik_esm/* useFormikContext */.u6)().setFieldValue;
    (0,react.useEffect)(function() {
        if ((updatedPrice === null || updatedPrice === void 0 ? void 0 : updatedPrice.finalCost) !== undefined) {
            setFieldValue("total", updatedPrice.finalCost);
        }
    }, [
        updatedPrice,
        setFieldValue
    ]);
    return null;
};
var ModalContent = function(param) {
    var propertyId = param.propertyId, guests = param.guests, total = param.total, bedrooms = param.bedrooms, property = param.property, taxesAndFees = param.taxesAndFees, totalCostPerNights = param.totalCostPerNights, totalWithoutStripe = param.totalWithoutStripe, bonuses = param.bonuses, numberOfFreeNights = param.numberOfFreeNights, freeNightsCost = param.freeNightsCost, freeNightsOldPrice = param.freeNightsOldPrice, translations = param.translations;
    var router = (0,next_router.useRouter)();
    var search = (0,SearchContext/* useSearchContext */.AB)().search;
    var startDate = search.startDate;
    var endDate = search.endDate;
    var ReservationSchema = es/* object */.Ry().shape({
        firstName: es/* string */.Z_().max(25).matches(RegExp("^'?\\p{L}+(?:[' ]\\p{L}+)*'?$", "u"), translations.form.error.validName[router.locale]).required(translations.form.error.requiredFirstName[router.locale]),
        lastName: es/* string */.Z_().max(25).matches(RegExp("^'?\\p{L}+(?:[' ]\\p{L}+)*'?$", "u"), translations.form.error.validName[router.locale]).required(translations.form.error.requiredLastName[router.locale]),
        email: es/* string */.Z_().matches(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, translations.form.error.validEmail[router.locale]).max(254).email(translations.form.error.validEmail[router.locale]).required(translations.form.error.requiredEmail[router.locale])
    });
    var handleCloseModal = (0,modalProvider/* useModalContext */.vR)().handleCloseModal;
    var isMobile = (0,ResponsiveContext/* useResponsive */.F)().isMobile;
    var ref = (0,react.useState)("details"), plans = ref[0], setPlans = ref[1];
    var ref1 = (0,react.useState)(false), skip = ref1[0], setSkip = ref1[1];
    var ref2 = (0,react.useState)(false), coupon = ref2[0], setCoupon = ref2[1];
    var ref3 = (0,react.useState)(false), updatedPrice = ref3[0], setUpdatedPrice = ref3[1];
    var ref4 = (0,react.useState)(""), reservationId = ref4[0], setReservationId = ref4[1];
    var ref5 = (0,react.useState)(null), reservationData = ref5[0], setReservationData = ref5[1];
    var ref6 = (0,react.useState)(null), paymentError = ref6[0], setPaymentError = ref6[1];
    var ref7 = (0,react.useState)({}), savedContact = ref7[0], setSavedContact = ref7[1];
    var isThankYou = plans === "thankYou";
    // Load saved contact info on mount
    (0,react.useEffect)(function() {
        var contact = (0,userContactStorage/* getUserContact */.ok)();
        setSavedContact(contact);
    }, []);
    var detailsProps = {
        guests: guests,
        total: total,
        startDate: startDate,
        endDate: endDate,
        bedrooms: bedrooms,
        property: property,
        updatedPrice: updatedPrice,
        setUpdatedPrice: setUpdatedPrice,
        setCoupon: setCoupon,
        taxesAndFees: taxesAndFees,
        totalCostPerNights: totalCostPerNights,
        totalWithoutStripe: totalWithoutStripe,
        bonuses: bonuses,
        numberOfFreeNights: numberOfFreeNights,
        freeNightsCost: freeNightsCost,
        freeNightsOldPrice: freeNightsOldPrice,
        translations: translations
    };
    var formInitialValues = {
        id: propertyId,
        startDate: startDate,
        endDate: endDate,
        bedrooms: bedrooms,
        total: Number(total),
        guests: guests,
        bonuses: bonuses,
        propertyName: property === null || property === void 0 ? void 0 : property.propertyTitle,
        firstName: savedContact.firstName || "",
        lastName: savedContact.lastName || "",
        email: savedContact.email || "",
        phone: savedContact.phone || null,
        car: null,
        transport: null,
        assistance: null,
        food: null,
        reservation: null
    };
    var ref8 = (0,react.useState)(formInitialValues), submitted = ref8[0], setSubmitted = ref8[1];
    // Handler to save contact info on field blur
    var handleFieldBlur = function(fieldName, value) {
        if (value) {
            (0,userContactStorage/* saveUserContact */.KO)((0,_define_property/* default */.Z)({}, fieldName, value));
        }
    };
    var handleSubmit = function(values, param) {
        var setSubmitting = param.setSubmitting;
        setSubmitting(true);
        if (plans === "details") {
            setPaymentError(null);
            // Save contact info when moving to next step
            (0,userContactStorage/* saveUserContact */.KO)({
                firstName: values.firstName,
                lastName: values.lastName,
                email: values.email
            });
            axios/* default.post */.Z.post("reservation/payment-intent", {
                params: values
            }).then(function() {
                //stripe verification if previous is valid
                //if everything checks, set Plans (thank you form)
                setPlans("payment");
                setSubmitted((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, submitted), {
                    email: values.email,
                    firstName: values.firstName,
                    lastName: values.lastName,
                    bedrooms: values.bedrooms,
                    guests: values.guests,
                    startDate: values.startDate,
                    endDate: values.endDate,
                    bonuses: values.bonuses,
                    propertyName: values.propertyName
                }));
            }).catch(function(err) {
                var ref, ref1, ref2;
                console.error("Payment intent creation failed:", err);
                setPaymentError(((ref = err.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message) || ((ref2 = translations.form.error.paymentIntentFailed) === null || ref2 === void 0 ? void 0 : ref2[router.locale]) || "Unable to initialize payment. Please try again.");
            }).finally(function() {
                setSubmitting(false);
            });
            return;
        }
        if (plans === "thankYou") {
            axios/* default.post */.Z.post("reservation/questions", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, values), {
                coupon: coupon,
                bonuses: bonuses,
                total: total,
                freeNights: numberOfFreeNights,
                freeNightlyRate: freeNightsCost,
                initialPrice: freeNightsOldPrice,
                reservationId: reservationId
            })).then(function() {
                handleCloseModal();
            }).catch(function(err) {
                return console.error(err);
            }).finally(function() {
                setSubmitting(false);
            });
            return;
        }
        setSubmitting(false);
    };
    if (plans !== "finish") {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Columns/* default */.Z, {
            variant: [
                isThankYou && "no-gutter"
            ],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* default */.Z, {
                    variant: [
                        isThankYou && "no-padding"
                    ],
                    spans: isThankYou || isMobile ? 12 : 7,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
                        onSubmit: handleSubmit,
                        enableReinitialize: true,
                        validationSchema: ReservationSchema,
                        initialValues: formInitialValues,
                        children: function(param) {
                            var values = param.values, setFieldValue = param.setFieldValue, errors = param.errors, touched = param.touched, isSubmitting = param.isSubmitting;
                            // Note: FormTotalSync handles syncing updatedPrice with form state
                            // It's rendered as a component to properly use hooks (see component above)
                            if (plans === "details") {
                                var ref;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, {
                                    className: (styles_module_default()).form,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormTotalSync, {
                                            updatedPrice: updatedPrice
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_step_contact, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: (styles_module_default()).form__title,
                                            children: translations.contactDetails[router.locale]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomField/* default */.Z, {
                                                    variant: [
                                                        "hidden"
                                                    ],
                                                    readOnly: true,
                                                    name: "id",
                                                    value: propertyId
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomField/* default */.Z, {
                                                    variant: [
                                                        "hidden"
                                                    ],
                                                    readOnly: true,
                                                    name: "startDate",
                                                    value: startDate
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomField/* default */.Z, {
                                                    variant: [
                                                        "hidden"
                                                    ],
                                                    readOnly: true,
                                                    name: "endDate",
                                                    value: endDate
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomField/* default */.Z, {
                                                    variant: [
                                                        "hidden"
                                                    ],
                                                    readOnly: true,
                                                    name: "bedrooms",
                                                    value: bedrooms
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomField/* default */.Z, {
                                                    variant: [
                                                        "hidden"
                                                    ],
                                                    readOnly: true,
                                                    name: "total",
                                                    value: Number(total)
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomField/* default */.Z, {
                                                    variant: [
                                                        "full-width"
                                                    ],
                                                    required: true,
                                                    maxLength: 20,
                                                    name: "firstName",
                                                    placeholder: translations.form.fields.firstName[router.locale],
                                                    className: (styles_module_default()).form__inputs,
                                                    onChange: function(e) {
                                                        setFieldValue("firstName", e.target.value.replace(/[0-9]/g, ""));
                                                    },
                                                    onBlur: function(e) {
                                                        return handleFieldBlur("firstName", e.target.value);
                                                    },
                                                    error: errors.firstName && (touched === null || touched === void 0 ? void 0 : touched.firstName),
                                                    withError: true
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomField/* default */.Z, {
                                                    variant: [
                                                        "full-width"
                                                    ],
                                                    maxLength: 20,
                                                    required: true,
                                                    name: "lastName",
                                                    placeholder: translations.form.fields.lastName[router.locale],
                                                    className: (styles_module_default()).form__inputs,
                                                    onChange: function(e) {
                                                        setFieldValue("lastName", e.target.value.replace(/[0-9]/g, ""));
                                                    },
                                                    onBlur: function(e) {
                                                        return handleFieldBlur("lastName", e.target.value);
                                                    },
                                                    error: errors.lastName && (touched === null || touched === void 0 ? void 0 : touched.lastName),
                                                    withError: true
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomField/* default */.Z, {
                                                    variant: [
                                                        "full-width"
                                                    ],
                                                    maxLength: 254,
                                                    name: "email",
                                                    required: true,
                                                    placeholder: translations.form.fields.email[router.locale],
                                                    type: "email",
                                                    className: (styles_module_default()).form__inputs,
                                                    onBlur: function(e) {
                                                        return handleFieldBlur("email", e.target.value);
                                                    },
                                                    error: errors.email && touched.email,
                                                    valid: values.email && !errors.email && touched.email,
                                                    withError: true
                                                })
                                            ]
                                        }),
                                        paymentError && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (styles_module_default()).form__error,
                                            role: "alert",
                                            children: paymentError
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                                            disabled: values.email === null || values.firstName === null || values.lastName === null || isSubmitting,
                                            children: isSubmitting ? ((ref = translations.form.fields.processing) === null || ref === void 0 ? void 0 : ref[router.locale]) || "Processing..." : translations.form.fields.continue[router.locale]
                                        })
                                    ]
                                });
                            }
                            if (plans === "payment") {
                                var ref1, ref2;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (styles_module_default()).form,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_step_payment, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: (styles_module_default()).form__title,
                                            children: translations.stripe.paymentDetails[router.locale]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(single_property_StripeComponent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                            translations: translations.stripe,
                                            setReservationId: setReservationId,
                                            setPlans: setPlans,
                                            setSkip: setSkip,
                                            setReservationData: setReservationData,
                                            updatedPrice: updatedPrice,
                                            coupon: coupon,
                                            freeNights: numberOfFreeNights,
                                            freeNightlyRate: freeNightsCost,
                                            initialPrice: freeNightsOldPrice
                                        }, submitted), {
                                            propertyId: (ref1 = detailsProps.property) === null || ref1 === void 0 ? void 0 : ref1.resource_id,
                                            listingId: (ref2 = detailsProps.property) === null || ref2 === void 0 ? void 0 : ref2.id,
                                            total: updatedPrice ? Number(updatedPrice.finalCost) : Number(total)
                                        }))
                                    ]
                                });
                            }
                            if (isThankYou) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalContent_ThankYou, {
                                    translations: translations.thankYou,
                                    setFieldValue: setFieldValue,
                                    reservationData: reservationData,
                                    isSubmitting: isSubmitting
                                });
                            }
                        }
                    })
                }),
                !isThankYou && /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* default */.Z, {
                    spans: isMobile ? 12 : 5,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalContent_Details, (0,_object_spread/* default */.Z)({}, detailsProps))
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (styles_module_default()).finish,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: (styles_module_default()).finish__title,
                children: skip ? translations.skip.title1[router.locale] : translations.skip.title2[router.locale]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (styles_module_default()).finish__subtitle,
                children: skip ? translations.skip.subtitle1[router.locale] : translations.skip.subtitle2[router.locale]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default()).finish__separator
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: (styles_module_default()).finish__description,
                children: [
                    translations === null || translations === void 0 ? void 0 : translations.skip.questions[router.locale],
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        rel: "nofollow",
                        href: "mailto:reservations@sxmsir.com",
                        children: "reservations@sxmsir.com"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                href: "/guest-experience",
                onClick: function() {
                    handleCloseModal();
                },
                arrow: false,
                variant: [
                    "color-accent"
                ],
                children: translations.skip.button[router.locale]
            })
        ]
    });
};
/* harmony default export */ var components_ModalContent = (ModalContent);


/***/ }),

/***/ 42998:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"separator":"styles_separator__LP5R2","separator--vertical":"styles_separator--vertical__XAMVo","separator--center":"styles_separator--center__qDfXg","separator--full-width":"styles_separator--full-width__WOn53"};

/***/ }),

/***/ 97503:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"srOnly":"styles_srOnly__B4zJr","progressIndicator":"styles_progressIndicator___u3Ad","progressIndicator__spinner":"styles_progressIndicator__spinner__qrfJ6","progressIndicator__message":"styles_progressIndicator__message__YjYIA","progressIndicator__steps":"styles_progressIndicator__steps__lYNtR","progressIndicator__step":"styles_progressIndicator__step__wcCC7","progressIndicator__step--completed":"styles_progressIndicator__step--completed__INJN5","progressIndicator__stepDot":"styles_progressIndicator__stepDot__ceXOI","progressIndicator__stepCheck":"styles_progressIndicator__stepCheck___6CqY","checkFadeIn":"styles_checkFadeIn__0VJxj","progressIndicator__step--active":"styles_progressIndicator__step--active__Px1u_","pulse":"styles_pulse__xHaFP","progressIndicator__step--pending":"styles_progressIndicator__step--pending__UXYNV","progressIndicator--compact":"styles_progressIndicator--compact__LV4qP","progressIndicator--dark":"styles_progressIndicator--dark__Zq5P2"};

/***/ }),

/***/ 78897:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spinner":"styles_spinner__sgQJp","loading":"styles_loading__2EGmZ","spinner--white":"styles_spinner--white__wuXJ0","spinner--darker":"styles_spinner--darker__oN4CN","spinner--black":"styles_spinner--black__LbiGp"};

/***/ }),

/***/ 39361:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"payment_form":"styles_payment_form__RrRnt","label":"styles_label__XbsoL","payment_message":"styles_payment_message__wqUmb","note":"styles_note__yI_e3","skip":"styles_skip__VdAft","payment_error_message":"styles_payment_error_message__j93b3","error_display":"styles_error_display__9ekG9","error_display__header":"styles_error_display__header__wEH9m","error_display__icon":"styles_error_display__icon__X2l2Y","error_display__content":"styles_error_display__content__cYrxD","error_display__title":"styles_error_display__title__j2M76","error_display__message":"styles_error_display__message__2Z_Ut","error_display__support":"styles_error_display__support__bUZba","error_display__support_text":"styles_error_display__support_text___XI7a","error_display__support_link":"styles_error_display__support_link__e_DIk","error_display__actions":"styles_error_display__actions__DECtc","error_display__refresh_button":"styles_error_display__refresh_button__NQ4bu","error_display__success_note":"styles_error_display__success_note__5MH6N","error_display__success_text":"styles_error_display__success_text__L1yra","error_display__reference":"styles_error_display__reference__PUH6_"};

/***/ }),

/***/ 61825:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"details":"styles_details__eVRu0","details__title":"styles_details__title__hYCEQ","details__bedroom":"styles_details__bedroom__Q_IaN","details__note":"styles_details__note__gRYJx","details__deposit_amount":"styles_details__deposit_amount__3qxmD","details__row":"styles_details__row__HEsxO","details__row--merged":"styles_details__row--merged__er5HC","details__slider":"styles_details__slider__PjMbK","form":"styles_form__iITWn","form__field":"styles_form__field__Hv58G","form__error":"styles_form__error__FVtPU","form__button":"styles_form__button__K8trt"};

/***/ }),

/***/ 37691:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__keywt","form__intro":"styles_form__intro__Jflwe","form__title":"styles_form__title__8_32V","form__additional":"styles_form__additional__JYKiQ","form__submit":"styles_form__submit__9UDLh","form__label":"styles_form__label__vnNIH","form__inputs":"styles_form__inputs__FdxZe","form--thanks":"styles_form--thanks__Bjn6l","thanks":"styles_thanks__E3Ir3","confirmation_details":"styles_confirmation_details__47bY4","confirmation_details__title":"styles_confirmation_details__title__b8zEa","confirmation_details__grid":"styles_confirmation_details__grid__t836L","confirmation_details__item":"styles_confirmation_details__item__Mu_wS","confirmation_details__item--full":"styles_confirmation_details__item--full__TR7YB","confirmation_details__label":"styles_confirmation_details__label__PYgpq","confirmation_details__value":"styles_confirmation_details__value__16Akd","confirmation_details__value--highlight":"styles_confirmation_details__value--highlight__Th6Ea","confirmation_details__note_inline":"styles_confirmation_details__note_inline__gZnFX","confirmation_details__note":"styles_confirmation_details__note__11Hw4","finish":"styles_finish__I4ew_","finish__title":"styles_finish__title__v_OsY","finish__subtitle":"styles_finish__subtitle__OrHxd","finish__separator":"styles_finish__separator__0WhjU","finish__description":"styles_finish__description__0m8oj"};

/***/ })

}]);